import {useHistoricosCreditoCaixa, idHistoricoCredito, descricaoHistoricoCredito, colunaHistoricosCredito, DetalheHistoricoCreditoCaixa} from './components/HistoricosCreditoCaixa';
import {colunaFormasPagamento} from './components/formasPagamentoMovimento';
import {resumirPrePagamentosCaixa} from './components/resumoPrePagamentosCaixa';
import {requisitarCaixaSeguro,exibirErroCaixa} from './components/caixaSeguroApi';
import {apiUrl} from './components/apiAmbiente';
import {formatarAcoesCaixa, iconeAcaoCaixa as iconeAcao, formatarIdMovimentoCaixa} from './components/acoesCaixa';
import MovimentoAgendasDetalhe from './MovimentoAgendasDetalhe';
import React, { useState, useEffect, useRef, useContext } from "react";
import { ReactSearchAutocomplete } from "react-search-autocomplete";
import { withRouter } from "react-router-dom";
import Loading from "./assets/loading4.gif";
import Logo from "./assets/MB_Logo.png";
import './caixamov.css';
import "./components/functions";
import 'react-tabulator/lib/styles.css'; // required styles
import 'react-tabulator/lib/css/tabulator.min.css'; // theme
import { ReactTabulator } from 'react-tabulator'; // for React 15.x, use import { React15Tabulator }
import { cl } from "./components/functions";
import axios from "axios";
import * as EmailValidator from 'email-validator';
import Inputmask from "inputmask";
import { CopyToClipboard } from 'react-copy-to-clipboard';
import moment from "moment";
import dateFormat from "dateformat";
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import { Link, animateScroll as scroll } from "react-scroll";
import Hotkeys from 'react-hot-keys';
import date from 'date-and-time';
import DualListBox from 'react-dual-listbox';
import 'react-dual-listbox/lib/react-dual-listbox.css';
import { DateTime } from 'luxon'
import {
  Document,
  HeadingLevel,
  ImageRun,
  Packer,
  Paragraph,
  Table,
  TableCell,
  TableRow,
  VerticalAlign,
  WidthType
} from "docx";
//import * as fs from "fs";
//const fs = require('fs')

var gGlobal = require('./components/globalvar.js');

// AUX FLEX: linhas virtuais exclusivas para a grade semanal. Não altera a API, vendas ou impressão.
function montarApontamentosComFlex(registros) {
  if (!Array.isArray(registros)) return registros;
  const adicionais = [];
  registros.forEach((r, indice) => {
    const nome = String(r.auxiliar || '').trim();
    const valor = Number(String(r.flex_receber || '0').replace(/\./g, '').replace(',', '.'));
    if (!nome || nome === '-' || !Number.isFinite(valor) || valor <= 0) return;
    adicionais.push({
      ...r,
      id: String(r.id) + '-FLEX-' + indice,
      prof: nome,
      serv: String(r.serv || '') + ' (Auxiliar FLEX)',
      valor: '0,00', insumos: '0,00', getnet: '0,00', antecip: '0,00',
      porc: String(r.flex_porc || ''), auxiliar: '-', flex_receber: '0,00',
      receber: valor.toLocaleString('pt-BR', {minimumFractionDigits: 2, maximumFractionDigits: 2}),
      linhaAuxFlex: true
    });
  });
  return registros.concat(adicionais);
}

const wordIcon = function (cell, formatterParams) { //plain text value
  return "<i class='far fa-file-word'></i>";
};
const editIcon = function (cell, formatterParams) { //plain text value
  return "<i class='fas fa-edit'></i>";
};
const iconContrato = function (cell, formatterParams) { //plain text value
  return "<i class='fas fa-file-download'></i>";
};
const iconwhatsappweb = function (cell, formatterParams) { //plain text value
  return "<i class='fa fa-whatsapp'></i>";
}

const iconLixeira = function (cell, formatterParams) { //plain text value
  //if (cell.getRow().getData().progress < 11){
  return "<i class='fa fa-trash-o'></i>";
  //} else {
  //  return "-";
  //}
}


global.gLog = [];
global.gOpencaixa = 1;
global.gSubTotal = 0;
global.gAlertaCaixaMov = 0;
global.gSubTotalVales = 0;
global.gSubTotalAgendas = 0;

function idAgendaApontamento(registro) {
  const valor = String(registro?.id ?? '').trim();
  const texto = registro?.linhaAuxFlex ? valor.split('-FLEX-')[0] : valor;
  if (!/^\d+$/.test(texto)) return null;
  const id = Number(texto);
  return Number.isSafeInteger(id) && id > 0 ? id : null;
}

function rowClick(e, row) {
  ////cl('ref table: ', this.ref.table); // this is the Tabulator table instance
  //cl("rowClick id: " + row.getData().id, row, e);
  ////cl(rep);

};


// Modal independente para recebimento de Ficha: não altera o lançamento manual existente.
function RecebimentoCCModal({ onClose, onSaved, caixa, usuario }) {
  const [clientes, setClientes] = useState([]);
  const [selecionado, setSelecionado] = useState(null);
  const [valor, setValor] = useState('');
  const [forma, setForma] = useState('');
  const [erro, setErro] = useState('');
  const [salvando, setSalvando] = useState(false);

  useEffect(() => {
    let ativo = true;
    const dados = new FormData();
    dados.append('apikey', '$#T#@!M%T@$MG@$OJG48ugyf987nszovhunfc4');
    dados.append('comp', '0');
    axios.post(apiUrl('listaCli.php'), dados)
      .then(r => { if (ativo) setClientes(Array.isArray(r.data) ? r.data : []); })
      .catch(() => { if (ativo) setErro('Não foi possível carregar os clientes.'); });
    return () => { ativo = false; };
  }, []);

  function valorCentavos(texto) {
    const t = String(texto || '').replace(/R\$|\s/g, '');
    const normalizado = t.includes(',') ? t.replace(/\./g, '').replace(',', '.') : t;
    if (!/^\d+(\.\d{1,2})?$/.test(normalizado)) return 0;
    return Math.round(Number(normalizado) * 100);
  }

  function confirmar() {
    const centavos = valorCentavos(valor);
    if (!selecionado || !Number.isInteger(Number(selecionado.id)) || Number(selecionado.id) <= 0) {
      setErro('Selecione um cliente da lista.'); return;
    }
    if (centavos <= 0) { setErro('Informe um valor válido maior que zero.'); return; }
    if (!['cash', 'debito', 'creditoavista', 'creditoparc', 'pix'].includes(forma)) {
      setErro('Selecione uma forma de pagamento.'); return;
    }
    setErro('');
    const descricao = `PG CC - ${selecionado.name} (${selecionado.id}) - ${selecionado.fone || 'SEM FONE'}`;
    confirmAlert({
      closeOnClickOutside: false,
      customUI: ({onClose: fecharConfirmacao}) => (
        <div className="custom-ui" style={{minWidth:320,maxWidth:520}}>
          <div className="modal-header"><h4 className="modal-title">Confirmar recebimento CC</h4></div>
          <div className="modal-body">
            <p><strong>Cliente:</strong> {selecionado.name} (ID {selecionado.id})</p>
            <p><strong>Telefone:</strong> {selecionado.fone || 'Não informado'}</p>
            <p><strong>Valor:</strong> {(centavos/100).toLocaleString('pt-BR',{style:'currency',currency:'BRL'})}</p>
            <p><strong>Forma:</strong> {{cash:'Dinheiro',debito:'Débito',creditoavista:'Crédito à vista',creditoparc:'Crédito parcelado',pix:'PIX'}[forma]}</p>
            <p style={{overflowWrap:'anywhere'}}><strong>Descrição:</strong> {descricao}</p>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary btn-sm" onClick={fecharConfirmacao}>Voltar</button>
            <button type="button" className="btn btn-success btn-sm" onClick={() => { fecharConfirmacao(); gravar(centavos); }}>Confirmar e lançar</button>
          </div>
        </div>
      )
    });
  }

  async function gravar(centavos) {
    if (salvando) return;
    setSalvando(true); setErro('');
    try {
      const dados = new FormData();
      dados.append('apikey', '$#T#@!M%T@$MG@$OJG48ugyf987nszovhunfc4');
      ['cliente','idagenda','idprof','dtvenc','desc','cash','troco','debito','creditoavista','creditoparc','pix','cc','acerto'].forEach(campo => dados.append(campo, ''));
      dados.append('ref', 'RECEBIMENTO_CC');
      dados.append('idcliente', String(selecionado.id));
      dados.append('caixa', String(caixa));
      dados.append('tipo', 'E');
      dados.append('valor', (centavos / 100).toFixed(2));
      dados.append('Fpg', forma);
      dados.append('user', String(usuario));
      const resposta = await requisitarCaixaSeguro('AddLancCxManual.php', dados);
      if (!resposta.data || resposta.data.ok !== true) throw new Error(resposta.data && resposta.data.erro || 'Não foi possível confirmar a gravação.');
      onSaved(resposta.data);
    } catch (e) {
      setErro((e.response && e.response.data && e.response.data.erro) || e.message || 'Falha ao gravar o recebimento.');
    } finally { setSalvando(false); }
  }

  return (
    <div className="custom-ui mbhair-receb-cc" style={{width:'min(92vw,600px)',maxWidth:'600px',overflow:'visible'}}>
      <div className="modal-header"><h4 className="modal-title">Recebimento CC</h4></div>
      <div className="modal-body">
        <div className="form-group mbhair-receb-cc-busca" style={{position:'relative',zIndex:20}}>
          <label>Pesquisar Cliente por parte do Nome ou Fone</label>
          <ReactSearchAutocomplete
            items={clientes}
            fuseOptions={{threshold:0.1,caseSensitive:false,keys:['name','fone']}}
            resultStringKeyName="name"
            onSelect={item => {setSelecionado(item);setErro('');}}
            onSearch={() => {if(selecionado) setSelecionado(null);}}
            onClear={() => setSelecionado(null)}
            styling={{height:'36px',borderRadius:'0.25rem',zIndex:20,backgroundColor:'#fff',fontSize:'14px'}}
            placeholder="Nome ou telefone..."
            formatResult={item => <span>{item.name} (ID {item.id}) - {item.fone || 'Sem telefone'}</span>}
          />
        </div>
        {selecionado && <div className="alert alert-info py-2">Selecionado: <strong>{selecionado.name}</strong> (ID {selecionado.id}) — {selecionado.fone || 'Sem telefone'}</div>}
        {selecionado && <div className="form-row">
          <div className="form-group col-md-6"><label>Valor R$</label><input type="text" className="form-control" value={valor} onChange={e=>setValor(e.target.value)} placeholder="0,00" autoComplete="off" /></div>
          <div className="form-group col-md-6"><label>Forma de Pagamento</label><select className="form-control" value={forma} onChange={e=>setForma(e.target.value)}>
            <option value="">selecione</option><option value="cash">Dinheiro</option><option value="debito">Débito</option><option value="creditoavista">Crédito à Vista</option><option value="creditoparc">Crédito Parc.</option><option value="pix">PIX</option>
          </select></div>
        </div>}
        {erro && <div className="alert alert-danger py-2">{erro}</div>}
      </div>
      <div className="modal-footer"><button type="button" className="btn btn-secondary btn-sm" disabled={salvando} onClick={onClose}>Cancelar</button><button type="button" className="btn btn-success btn-sm" disabled={!selecionado || salvando} onClick={confirmar}>{salvando?'Gravando...':'Lançar'}</button></div>
    </div>
  );
}

function Gerador() {

  const formatData = function (cell, formatterParams, onRendered) {
    //cell - the cell component
    //formatterParams - parameters set for the column
    //onRendered - function to call when the formatter has been rendered
    let dia = cell.getValue().substr(8, 2)
    let mes = cell.getValue().substr(5, 2)
    let ano = cell.getValue().substr(0, 4)
    let result = dia + '/' + mes + '/' + ano

    return result; //return the contents of the cell;  
  }

  const adultCalc = function (values, data, calcParams) {
    //values - array of column values
    //data - all table data
    //calcParams - params passed from the column definition object
    //cl(values, data, calcParams);

    var calc = 0;

    values.forEach(function (value) {
      calc = calc + realParaNumber(value)
    });

    return calc.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
  }

  const [Atu, setAtu] = useState([]);
  const [rep, setrep] = useState([]);
  const [repCaixaOpen, setrepCaixaOpen] = useState([]);
  const [FinalizaPag, setFinalizaPag] = useState([]);
  const [AtuLanc, setAtuLanc] = useState([]);
  const [Lanc, setLanc] = useState([]);
  const [LancSelected, setLancSelected] = useState([]);
  const [openCaixa, setopenCaixa] = useState([]);
  const [AtuLancamentos, setAtuLancamentos] = useState('');
  const [Lancamentos, setLancamentos] = useState('');
  const historicosCredito=useHistoricosCreditoCaixa(global.gCaixaId,AtuLancamentos,Lancamentos);
  function abrirDetalheMovimento(r){if(r.historico_credito)historicosCredito.abrir(r);else setMovimentoDetalhe(r);}
  const [AtuRelComiss, setAtuRelComiss] = useState('');
  const [RelComiss, setRelComiss] = useState('');
  const [AtuRelComissResumo, setAtuRelComissResumo] = useState('');
  const [RelComissResumo, setRelComissResumo] = useState('');
  const [EditLancamentos, setEditLancamentos] = useState('');
  const [AddLancManual, setAddLancManual] = useState('');
  const [FechaCaixa, setFechaCaixa] = useState('');
  const [ProfisPre, setProfisPre] = useState([]);
  const [Profis, setProfis] = useState([]);

  const API_OPERACIONAL = apiUrl('CorrecaoOperacional.php');
  const [movimentoDetalhe,setMovimentoDetalhe]=useState(null);
  const [agendaDetalheId,setAgendaDetalheId]=useState(null);
  const [adminAgenda,setAdminAgenda]=useState(null);
  const [adminMotivo,setAdminMotivo]=useState('');
  const [adminAcao,setAdminAcao]=useState('reverter');
  const [adminErro,setAdminErro]=useState('');
  const [adminCarregando,setAdminCarregando]=useState(false);
  const [adminConfirmando,setAdminConfirmando]=useState(false);
  async function apiAdminAgenda(acao,row,motivo=''){
    const fd=new FormData();fd.set('token',sessionStorage.getItem('KEY_APP_BGG')||'');fd.set('acao',acao);fd.set('mov_id',String(row.id));if(motivo)fd.set('justificativa',motivo);
    const r=await axios.post(apiUrl('AdministrarPagamentoAgenda.php'),fd);
    if(!r.data?.ok)throw new Error(r.data?.erro||'Operação indisponível');return r.data;
  }
  async function abrirAdminAgenda(row){
    setAdminErro('');setAdminMotivo('');setAdminAcao('reverter');setAdminConfirmando(false);setAdminCarregando(true);
    try{const info=await apiAdminAgenda('consultar',row);setAdminAgenda({row,info});}
    catch(e){setAdminErro(e.response?.data?.erro||e.message||'Não foi possível verificar a elegibilidade');setAdminAgenda({row,info:null});}
    finally{setAdminCarregando(false);}
  }
  async function executarAdminAgenda(){
    if(!adminAgenda||!adminAgenda.info||adminCarregando)return;
    if(adminMotivo.trim().length<20){setAdminErro('Informe uma justificativa de pelo menos 20 caracteres.');return;}
    setAdminCarregando(true);setAdminErro('');
    try{const r=await apiAdminAgenda(adminAcao,adminAgenda.row,adminMotivo.trim());setAdminAgenda(null);setAdminConfirmando(false);setAtuLancamentos({caixa:global.gCaixaId,alteracao:Date.now()});setAtuRelComiss({alteracao:Date.now()});setAtuRelComissResumo({alteracao:Date.now()});modalBase('Operação administrativa concluída','Movimento #'+r.movimento+' · Auditoria #'+r.auditoria_id);}
    catch(e){setAdminErro(e.response?.data?.erro||e.message||'Falha na operação');}
    finally{setAdminCarregando(false);}
  }

  const focoMovimentoRef=useRef(false);
  const [resumoMovimento, setResumoMovimento] = useState(null);
  const [resumoCarregando, setResumoCarregando] = useState(false);
  const [resumoErro, setResumoErro] = useState('');
  const [resumoAgendas, setResumoAgendas] = useState([]);

  const [operacao, setOperacao] = useState(null);
  const [operacaoErro, setOperacaoErro] = useState('');
  const [operacaoMotivo, setOperacaoMotivo] = useState('');
  const [operacaoDescricao, setOperacaoDescricao] = useState('');
  const [operacaoValor, setOperacaoValor] = useState('');
  const [operacaoAgenda, setOperacaoAgenda] = useState('');
  const [operacaoServicos, setOperacaoServicos] = useState([]);
  const [operacaoLinha, setOperacaoLinha] = useState('');
  const [operacaoDestino, setOperacaoDestino] = useState('');
  const [operacaoExecutando, setOperacaoExecutando] = useState(false);
  function confirmarAdministrativo(titulo, conteudo, aoConfirmar) {
    confirmAlert({closeOnClickOutside:false, customUI:({onClose}) => <div className="custom-ui" style={{minWidth:360,maxWidth:620,padding:0,overflow:'hidden',borderRadius:5}}>
      <div className="modal-header bg-info text-white"><h5 className="modal-title">{titulo}</h5></div>
      <div className="modal-body">{conteudo}</div>
      <div className="modal-footer" style={{display:'flex',justifyContent:'flex-end',gap:8}}>
        <button type="button" className="btn btn-secondary btn-sm" onClick={onClose}>Voltar</button>
        <button type="button" className="btn btn-success btn-sm" onClick={() => {onClose();aoConfirmar();}}>Confirmar e registrar</button>
      </div></div>});
  }
  const novoCodigoAuditoria = () => 'MB' + Date.now().toString(36) + Math.random().toString(36).slice(2,20);
  async function apiOperacional(acao, campos={}) {
    const form=new FormData();form.append('token',sessionStorage.getItem('KEY_APP_BGG')||'');form.append('acao',acao);
    Object.keys(campos).forEach(k=>form.append(k,String(campos[k])));
    const r=await axios.post(API_OPERACIONAL,form);if(!r.data||!r.data.ok)throw new Error((r.data&&r.data.erro)||'Falha na API.');return r.data;
  }
  async function abrirResumoMovimento(row) {
    if (!row || !row.id) return;
    setResumoMovimento(row);
    setResumoAgendas([]);
    setResumoErro('');
    const ids = [...new Set(String(row.idagenda || '').split(',').map(v=>v.trim()).filter(v=>/^\d+$/.test(v)))];
    if (!ids.length) return;
    setResumoCarregando(true);
    try {
      const dados = await Promise.all(ids.map(id => apiOperacional('consultar_servicos', {agenda_id:id})));
      setResumoAgendas(dados.map((r,i)=>({id:ids[i],agenda:r.agenda,servicos:r.servicos||[]})));
    } catch (err) {
      setResumoErro((err.response && err.response.data && err.response.data.erro) || err.message || 'Não foi possível consultar os serviços.');
    } finally { setResumoCarregando(false); }
  }
  function clicarLinhaMovimento(e, row) {
    if (e.target && e.target.closest && e.target.closest('[data-acao]')) return;
    abrirDetalheMovimento(row.getData());
  }
  function abrirMovimentoManual(row) {
    const manual=!String(row.idagenda||'').trim() && !String(row.idprof||'').trim() && !String(row.cliente||'').trim() && ['E','S'].includes(row.tipo) && row.status==='inicial' && (String(row.ref||'')!=='RECEBIMENTO_CC' || (Number(row.idcliente)>0 && row.tipo==='E'));
    if(!manual){setOperacaoErro("Este movimento não é manual independente ou não está disponível para edição.");return;}
    setOperacao({tipo:'manual',row});setOperacaoDescricao(row.descricao||'');setOperacaoValor(String(row.valor||0).replace('.',','));setOperacaoMotivo('');setOperacaoErro('');
  }
  async function abrirTransferencia(row) {
    const id=Number(String(row.idagenda||'').trim());if(!Number.isInteger(id)||id<=0)return;
    setOperacao({tipo:'profissional',row});setOperacaoAgenda(String(id));setOperacaoMotivo('');setOperacaoErro('');setOperacaoServicos([]);setOperacaoLinha('');setOperacaoDestino('');
    try {const r=await apiOperacional('consultar_servicos',{agenda_id:id});setOperacaoServicos(r.servicos||[]);}catch(e){setOperacaoErro((e.response&&e.response.data&&e.response.data.erro)||e.message);}
  }
  function confirmarOperacao(acao) {
    try {
      if(operacaoMotivo.trim().length<20)throw new Error('Justificativa obrigatória: mínimo de 20 caracteres.');
      if(acao==='movimento_editar' && (!operacaoDescricao.trim()||centavosValor(operacaoValor)<=0))throw new Error('Informe descrição e valor válido.');
      if(acao.startsWith('transferir') && (!operacaoDestino || (acao==='transferir_servico'&&!operacaoLinha)))throw new Error('Selecione profissional de destino e serviço, quando aplicável.');
      confirmarAdministrativo('Confirmar alteração administrativa',<><p><b>{acao==='movimento_cancelar'?'Cancelar movimento':acao==='movimento_editar'?'Editar movimento':acao==='transferir_agenda'?'Transferir agenda completa':'Transferir serviço'}</b></p>
        <p>Registro: {operacao.row.id} {acao.startsWith('transferir')?'· Agenda '+operacaoAgenda:''}</p>
        <p><b>Justificativa:</b> {operacaoMotivo.trim()}</p><div className="alert alert-warning">Alteração imediata e auditada. O proprietário receberá a ocorrência no sistema.</div></>,()=>executarOperacao(acao));
    }catch(e){setOperacaoErro(e.message);}
  }
  async function executarOperacao(acao) {
    if(operacaoExecutando)return;setOperacaoExecutando(true);setOperacaoErro('');
    try {
      const campos={mov_id:operacao.row.id,agenda_id:operacaoAgenda,lanc_id:operacaoLinha,novo_prof:operacaoDestino,
        justificativa:operacaoMotivo.trim(),codigo_requisicao:novoCodigoAuditoria(),descricao:operacaoDescricao.trim(),valor:converterMoeda(operacaoValor).toFixed(2)};
      const r=await apiOperacional(acao,campos);setOperacao(null);
      setAtuLancamentos({caixa:global.gCaixaId,alteracao:Date.now()});setAtuRelComiss({alteracao:Date.now()});setAtuRelComissResumo({alteracao:Date.now()});
      modalBase('Correção registrada','Ocorrência nº '+r.ocorrencia_id+'.');
    }catch(e){setOperacaoErro((e.response&&e.response.data&&e.response.data.erro)||e.message);}finally{setOperacaoExecutando(false);}
  }
  // Correção de forma de pagamento: piloto OS 57399, valor total imutável.
  const [correcaoMov, setCorrecaoMov] = useState(null);
  const [correcaoValores, setCorrecaoValores] = useState({});
  const [correcaoOriginal, setCorrecaoOriginal] = useState({});
  const [correcaoMotivo, setCorrecaoMotivo] = useState('');
  const [correcaoErro, setCorrecaoErro] = useState('');
  const [correcaoSalvando, setCorrecaoSalvando] = useState(false);
  const [correcaoAberturaOK, setCorrecaoAberturaOK] = useState(false);
  const camposPagamento = [
    ['cash', 'Dinheiro'], ['troco', 'Troco'], ['debito', 'Débito'],
    ['creditoavista', 'Crédito à vista'], ['creditoparc', 'Crédito parcelado'],
    ['pix', 'PIX'], ['cc', 'Ficha (CC)']
  ];
  const dinheiroBR = centavos => (centavos / 100).toLocaleString('pt-BR', {minimumFractionDigits:2, maximumFractionDigits:2});
  const centavosValor = valor => {
    const t = String(valor == null ? '0' : valor).trim().replace(/\s/g, '');
    if (!t) return 0;
    const normalizado = t.includes(',') ? t.replace(/\./g, '').replace(',', '.') : t;
    if (!/^\d+(?:\.\d{1,2})?$/.test(normalizado)) throw new Error('Valor inválido: ' + t);
    return Math.round(Number(normalizado) * 100);
  };
  const converterMoeda = valor => centavosValor(valor) / 100;
  const formataCampo = valor => dinheiroBR(centavosValor(valor));
  const pagamentoCampos = camposPagamento.map(([campo]) => campo).filter(campo => campo !== 'troco');
  // Mantém o valor total; a modalidade de maior saldo original absorve a diferença.
  function ajustarPagamento(campo, digitado) {
    setCorrecaoValores(anterior => {
      const atualizado = {...anterior, [campo]: digitado};
      try {
        if (campo === 'troco') return anterior; // Troco não é modalidade de recebimento.
        const total = centavosValor(correcaoMov.valor);
        const origem = pagamentoCampos.filter(f => f !== campo)
          .sort((a,b) => centavosValor(correcaoOriginal[b]) - centavosValor(correcaoOriginal[a]))[0];
        const somaOutros = pagamentoCampos.filter(f => f !== origem)
          .reduce((s,f) => s + centavosValor(atualizado[f]), 0);
        const restante = total - somaOutros;
        if (restante >= 0) atualizado[origem] = dinheiroBR(restante);
        return atualizado;
      } catch (e) { return atualizado; }
    });
  }
  async function abrirCorrecaoMov(row) {
    if (!/^\d+$/.test(String(row.idagenda || '').trim()) || String(global.gTipoUser) !== 'A') return;
    const valores = {};
    camposPagamento.forEach(([campo]) => { valores[campo] = formataCampo(row[campo]); });
    setCorrecaoMov(row); setCorrecaoValores(valores); setCorrecaoOriginal(valores);
    setCorrecaoMotivo(''); setCorrecaoErro(''); setCorrecaoAberturaOK(false);
    try {
      const token = sessionStorage.getItem('KEY_APP_BGG');
      const form = new FormData();
      form.append('token', token || ''); form.append('mov_id', String(row.id)); form.append('acao', 'abertura');
      const abertura = await axios.post(apiUrl('CorrecaoRecebimento57399.php'), form);
      if (!abertura.data || !abertura.data.abertura_registrada) throw new Error('Registro de abertura não confirmado.');
      setCorrecaoAberturaOK(true);
    } catch (erro) {
      setCorrecaoErro('Não foi possível registrar a abertura da edição. Nenhuma alteração pode ser gravada até regularizar o acesso. ' + ((erro.response && erro.response.data && erro.response.data.erro) || erro.message));
    }
  }
  function salvarCorrecaoMov() {
    if (correcaoSalvando || !correcaoMov || !correcaoAberturaOK) return;
    setCorrecaoErro('');
    try {
      if (correcaoMotivo.trim().length < 20) throw new Error('Descreva o motivo com pelo menos 20 caracteres.');
      const valores = {}; let soma = 0;
      camposPagamento.forEach(([campo]) => {
        const cents = centavosValor(correcaoValores[campo]);
        valores[campo] = (cents / 100).toFixed(2);
        soma += (campo === 'troco' ? -1 : 1) * cents;
      });
      if (soma !== centavosValor(correcaoMov.valor)) throw new Error('A soma líquida das formas de pagamento deve manter o valor original.');
      const alteracoes = camposPagamento.filter(([campo]) => centavosValor(correcaoOriginal[campo]) !== centavosValor(correcaoValores[campo]));
      if (!alteracoes.length) throw new Error('Nenhuma alteração foi realizada.');
      const detalhes = alteracoes.map(([campo, rotulo]) => rotulo + ': ' + correcaoOriginal[campo] + ' → ' + dinheiroBR(centavosValor(correcaoValores[campo]))).join('\n');
      confirmarAdministrativo('Confirmar correção financeira',
        <><p><b>OS {correcaoMov.idagenda} · Movimento #{correcaoMov.id}</b></p><pre style={{whiteSpace:'pre-wrap',fontFamily:'inherit'}}>{detalhes}</pre>
          <p>Total preservado: <b>R$ {dinheiroBR(centavosValor(correcaoMov.valor))}</b></p>
          <p><b>Justificativa:</b> {correcaoMotivo.trim()}</p>
          <div className="alert alert-warning">Esta alteração ficará registrada para o Auditor do sistema. Confirma?</div></>,
        () => executarCorrecaoMov(valores));
    } catch (erro) { setCorrecaoErro(erro.message || 'Revise os valores.'); }
  }
  async function executarCorrecaoMov(valores) {
    if (correcaoSalvando) return;
    setCorrecaoSalvando(true); setCorrecaoErro('');
    try {
      const token = sessionStorage.getItem('KEY_APP_BGG');
      if (!token) throw new Error('Sua sessão expirou. Entre novamente.');
      const form = new FormData();
      form.append('token', token); form.append('mov_id', String(correcaoMov.id));
      form.append('justificativa', correcaoMotivo.trim());
      form.append('codigo_requisicao', 'MB' + Date.now().toString(36) + Math.random().toString(36).slice(2, 16));
      Object.keys(valores).forEach(campo => form.append(campo, valores[campo]));
      const resp = await axios.post(apiUrl('CorrecaoRecebimento57399.php'), form);
      if (!resp.data || !resp.data.ok) throw new Error((resp.data && resp.data.erro) || 'Não foi possível gravar a correção.');
      setCorrecaoMov(null);
      setAtuLancamentos({ caixa: global.gCaixaId, alteracao: Date.now() });
      setAtuRelComiss({ alteracao: Date.now() });
      setAtuRelComissResumo({ alteracao: Date.now() });
      modalBase('Correção registrada', 'Recebimento atualizado. Ocorrência nº ' + resp.data.ocorrencia_id);
    } catch (erro) { setCorrecaoErro((erro.response && erro.response.data && erro.response.data.erro) || erro.message || 'Erro ao salvar.'); }
    finally { setCorrecaoSalvando(false); }
  }
  const [DocNow, setDocNow] = useState([]);
  const isFirstRunAtuLanc = useRef(true);
  const isFirstRunOpenCaixa = useRef(true);
  const isFirstRunAtuLancamentos = useRef(true);
  const isFirstRunAtuRelAtuComiss = useRef(true);
  const isFirstRunAtuRelAtuComissResumo = useRef(true);
  const isFirstRunEditLancamentos = useRef(true);
  const isFirstRunFinalizaPag = useRef(true);
  const isFirstRunAddLancManual = useRef(true);
  const isFirstRunFechaCaixa = useRef(true);

  moment.updateLocale('pt-br', {
    week: {
      dow: 1,
      //doy: 1,
    },
  });

  useEffect(() => {

    let ignoreProf = false;
    async function fetchprofis() {
      var bodyFormData = new FormData();
      bodyFormData.set('apikey', '$#T#@!M%T@$MG@$OJG48ugyf987nszovhunfc4');
      //bodyFormData.set('doc', global.gDoc);
      //bodyFormData.set('password', password);
      //bodyFormData.append('password', 'senha');
      const response = await axios({
        method: 'post',

        //url: global.gLinkBase + '/appyou/rest.php?apikey=398738379696650578637067567569346',
        url: apiUrl('listaProfisSel.php'),
        // url: 'http://192.168.99.250:3333/listNewContacs',

        //port: 3000,
        data: bodyFormData,
        config: { headers: { 'Content-Type': 'multipart/form-data' } }
      })


      if (!ignoreProf) {
        const redata = response['data'];
        //cl('redata', redata);

        setProfis(redata);
        //setLocalizer(ll);
        ignoreProf = true;

        //setEventosPRE(redata);

        //let eleLoading = document.getElementById('divLoad');
        //eleLoading.style.display = 'none';
      }
    }
    fetchprofis();

    /*     const resourceMap = [
          { resourceId: 1, resourceTitle: 'Marcio' },
          { resourceId: 2, resourceTitle: 'Jorge Estrela' },
          { resourceId: 3, resourceTitle: 'Kaka' },
          { resourceId: 4, resourceTitle: 'Manicure1' },
          { resourceId: 5, resourceTitle: 'Manicure2' },
          { resourceId: 6, resourceTitle: 'Manicure3' },
          { resourceId: 7, resourceTitle: 'Manicure4' },
          { resourceId: 8, resourceTitle: 'Manicure5' },
          { resourceId: 9, resourceTitle: 'Manicure6' },
          { resourceId: 10, resourceTitle: 'Manicure7' },
          { resourceId: 11, resourceTitle: 'Manicure8' },
          { resourceId: 12, resourceTitle: 'Manicure9' },
          { resourceId: 13, resourceTitle: 'Manicure10' },
          { resourceId: 12, resourceTitle: 'Manicure11' },
        ] */

  }, [ProfisPre])

  useEffect(() => {


    //cl("Profis",Profis)


  }, [Profis])


  useEffect(() => {


  }, [rep])

  useEffect(() => {


  }, [Lanc])

  useEffect(() => {

    /*     cl("moment0",moment().day(0).format('YYYY-MM-DD'));
        cl("moment1",moment().day(1).format('YYYY-MM-DD'));
        cl("moment2",moment().day(2).format('YYYY-MM-DD'));
        cl("moment3",moment().day(3).format('YYYY-MM-DD'));
        cl("moment4",moment().day(4).format('YYYY-MM-DD'));
        cl("moment5",moment().day(5).format('YYYY-MM-DD'));
        cl("moment6",moment().day(6).format('YYYY-MM-DD'));
        cl("moment7",moment().day(7).format('YYYY-MM-DD')); */


  }, [RelComiss])

  useEffect(() => {



  }, [RelComissResumo])

  useEffect(() => {
    if (isFirstRunAddLancManual.current) {
      isFirstRunAddLancManual.current = false;
      //cl("FirstRunDados false")
      return;
    }
    let ignore = false;
    cl("AddLancManual", AddLancManual)

    const { tipo, desc, valor, idprof, Fpg, dtvenc, acerto } = AddLancManual
    //cl("idagenda", idagenda)
    async function fetchdata() {
      var bodyFormData = new FormData();
      bodyFormData.set('apikey', '$#T#@!M%T@$MG@$OJG48ugyf987nszovhunfc4');
      bodyFormData.set('cliente', idprof);
      bodyFormData.set('caixa', global.gCaixaId);
      bodyFormData.set('tipo', tipo);
      bodyFormData.set('idprof', idprof);
      bodyFormData.set('desc', desc);
      bodyFormData.set('valor', valor);
      bodyFormData.set('dtvenc', dtvenc);
      bodyFormData.set('acerto', acerto);
      bodyFormData.set(Fpg, valor);
      bodyFormData.set('user', global.gIdUser);
      const response = await requisitarCaixaSeguro('AddLancCxManual.php',bodyFormData);
      //cl("response_data", response['data'])
      //setAtuLancamentos({ idagenda: global.gParams })

      setAtuLancamentos({ '0': '0' });
      setAtuRelComiss({ '0': '0' });
      if (!ignore) {
        const redata = [{}];
        const redata2 = response['data'];
        if (redata2) {
          //setLancamentos(redata2);
          //CloseEditContr();
        } else {
          //setLancamentos(redata);
        }


      }
    }
    fetchdata().catch(exibirErroCaixa);
    return () => { ignore = true };
  }, [AddLancManual])

  useEffect(() => {
    if (isFirstRunFechaCaixa.current) {
      isFirstRunFechaCaixa.current = false;
      //cl("FirstRunDados false")
      return;
    }
    let ignore = false;
    cl("FechaCaixa", FechaCaixa)

    const { sangria, vfinal } = FechaCaixa
    //cl("idagenda", idagenda)
    async function fetchdata() {
      var bodyFormData = new FormData();
      bodyFormData.set('apikey', '$#T#@!M%T@$MG@$OJG48ugyf987nszovhunfc4');
      bodyFormData.set('caixa', global.gCaixaId);
      bodyFormData.set('tipo', 'F');
      bodyFormData.set('desc', 'Fechamento de Caixa');
      bodyFormData.set('valor', sangria);
      bodyFormData.set('valorfinal', vfinal);
      bodyFormData.set('cash', sangria);
      bodyFormData.set('user', global.gIdUser);
      const response = await requisitarCaixaSeguro('FechaCaixa.php',bodyFormData);
      //cl("response_data", response['data'])
      //setAtuLancamentos({ idagenda: global.gParams })
      setAtuLancamentos({ '0': '0' });
      setAtuRelComiss({ '0': '0' });
      window.open("/caixa", "_self");
      if (!ignore) {
        const redata = [{}];
        const redata2 = response['data'];
        if (redata2) {
          //setLancamentos(redata2);
          //CloseEditContr();
        } else {
          //setLancamentos(redata);
        }


      }
    }
    fetchdata().catch(exibirErroCaixa);
    return () => { ignore = true };
  }, [FechaCaixa])



  useEffect(() => {

    //cl("LancSelected", LancSelected)
    if (LancSelected) {

      global.gLancSelected = LancSelected.toString();
    } else {

      global.gLancSelected = 'nenhum';
    }


  }, [LancSelected])

  useEffect(() => {



  }, [DocNow])

  useEffect(() => {
    if (isFirstRunAtuLancamentos.current) {
      isFirstRunAtuLancamentos.current = false;
      //cl("FirstRunDados false")
      return;
    }
    let ignore = false;

    //const { idagenda } = AtuLancamentos
    //cl("idagenda", idagenda)
    async function fetchdata() {
      var bodyFormData = new FormData();
      bodyFormData.set('apikey', '$#T#@!M%T@$MG@$OJG48ugyf987nszovhunfc4');
      //bodyFormData.set('caixa', 4);
      bodyFormData.set('caixa', global.gCaixaId);
      const urlfull = apiUrl('listaCaixaMov.php');
      const response = await axios({
        method: 'post',
        url: urlfull,
        data: bodyFormData,
        config: { headers: { 'Content-Type': 'multipart/form-data' } }
      })
      //cl("response_data_listaCaixaMov", response['data'])
      if (!ignore) {
        const redata = [{}];
        const redata2 = response['data'];
        if (redata2) {
          setLancamentos(redata2);
        } else {
          setLancamentos(redata);

        }
        //const redata = [{prop:"1210140551/19", contr:"C1210140551/19",cliente:"CONDOMINIO EDIFICIO VILA CAROLINA",tipo:"Auditoria de Gestão",status:"Editando"}];
        //cl(redata);


        let eleLoading = document.getElementById('divLoad');
        if (eleLoading) { eleLoading.style.display = 'none'; };
      }
    }
    fetchdata()
    //cl('gcontrato', gGlobal.gContrato);

    return () => { ignore = true };
  }, [AtuLancamentos])

  useEffect(() => {
    if (isFirstRunAtuRelAtuComiss.current) {
      isFirstRunAtuRelAtuComiss.current = false;
      //cl("FirstRunDados false")
      return;
    }
    let ignore = false;

    //const { idagenda } = AtuLancamentos
    //cl("idagenda", idagenda)
    async function fetchdata() {
      var bodyFormData = new FormData();
      bodyFormData.set('apikey', '$#T#@!M%T@$MG@$OJG48ugyf987nszovhunfc4');
      bodyFormData.set('dtinit', moment().day(1).format('YYYY-MM-DD 00:00:00'));
      bodyFormData.set('dtfim', moment().day(7).format('YYYY-MM-DD 23:59:59'));
      bodyFormData.set('marcio', 0);
      bodyFormData.set('pdeb', 1.79);
      bodyFormData.set('pcred', 2.55);
      bodyFormData.set('pcredp', 4.9);
      bodyFormData.set('antecip', 3.6);
      bodyFormData.set('caixa', global.gCaixaId);
      const urlfull = apiUrl('listaRelComiss.php');
      const response = await axios({
        method: 'post',
        url: urlfull,
        data: bodyFormData,
        config: { headers: { 'Content-Type': 'multipart/form-data' } }
      })
      //cl((moment().day(1).format('YYYY-MM-DD 00:00:00')));
      //cl((moment().day(7).format('YYYY-MM-DD 23:59:59')));
      //cl(global.gCaixaId);
      //cl("response_data_listaRelComiss", response['data'])
      if (!ignore) {
        const redata = [{}];
        const redata2 = response['data'];
        if (redata2) {
          setRelComiss(redata2);
        } else {
          setRelComiss(redata);

        }
        //const redata = [{prop:"1210140551/19", contr:"C1210140551/19",cliente:"CONDOMINIO EDIFICIO VILA CAROLINA",tipo:"Auditoria de Gestão",status:"Editando"}];
        //cl(redata);


        let eleLoading = document.getElementById('imgloadingRelComiss');
        if (eleLoading) { eleLoading.style.display = 'none'; };
      }
    }
    fetchdata()
    //cl('gcontrato', gGlobal.gContrato);

    return () => { ignore = true };
  }, [AtuRelComiss])

  useEffect(() => {
    if (isFirstRunAtuRelAtuComissResumo.current) {
      isFirstRunAtuRelAtuComissResumo.current = false;
      //cl("FirstRunDados false")
      return;
    }
    let ignore = false;

    //const { idagenda } = AtuLancamentos
    //cl("idagenda", idagenda)
    async function fetchdata() {
      var bodyFormData = new FormData();
      bodyFormData.set('apikey', '$#T#@!M%T@$MG@$OJG48ugyf987nszovhunfc4');
      bodyFormData.set('dtinit', moment().day(1).format('YYYY-MM-DD 00:00:00'));
      bodyFormData.set('dtfim', moment().day(7).format('YYYY-MM-DD 23:59:59'));
      bodyFormData.set('marcio', 0);      
      bodyFormData.set('pdeb', 1.79);
      bodyFormData.set('pcred', 2.55);
      bodyFormData.set('pcredp', 4.9);
      bodyFormData.set('antecip', 3.6);
      bodyFormData.set('caixa', global.gCaixaId);
      const urlfull = apiUrl('listaRelComissResumo.php');
      const response = await axios({
        method: 'post',
        url: urlfull,
        data: bodyFormData,
        config: { headers: { 'Content-Type': 'multipart/form-data' } }
      })
      //cl("response_data", response['data'])
      if (!ignore) {
        const redata = [{}];
        const redata2 = response['data'];
        if (redata2) {
          setRelComissResumo(redata2);
          //cl("redata2", redata2)
        } else {
          setRelComissResumo(redata);
         // cl("redata", redata)


        }
        //const redata = [{prop:"1210140551/19", contr:"C1210140551/19",cliente:"CONDOMINIO EDIFICIO VILA CAROLINA",tipo:"Auditoria de Gestão",status:"Editando"}];
        //cl(redata);


        let eleLoading = document.getElementById('imgloadingRelComiss');
        if (eleLoading) { eleLoading.style.display = 'none'; };
      }
    }
    fetchdata()
    //cl('gcontrato', gGlobal.gContrato);

    return () => { ignore = true };
  }, [AtuRelComissResumo])

  useEffect(() => {
    if (isFirstRunFinalizaPag.current) {
      isFirstRunFinalizaPag.current = false;
      //cl("FirstRunDados false")
      return;
    }

  }, [FinalizaPag])


  useEffect(() => {
    if (isFirstRunEditLancamentos.current) {
      isFirstRunEditLancamentos.current = false;
      //cl("FirstRunDados false")
      return;
    }
    let ignore = false;


    return () => { ignore = true };
  }, [EditLancamentos])

  useEffect(() => {

    global.gSubTotal = 0;
    global.gCash = 0;
    global.gDebito = 0;
    global.gCCv = 0;
    global.gCCp = 0;
    global.gPix = 0;
    global.gCC = 0;
    global.gSubTotalVales = 0;
    global.gSubTotalAgendas = 0;    
    global.gSubTotalAgendasCash = 0;
    global.gSubTotalAgendasCartao = 0;
    global.gSubTotalAgendasCC = 0;
    global.gSubTotalAgendasPix = 0;    

    //cl("Lancamentos", Lancamentos);
    if (Lancamentos.length > 0) {


      var i;

      for (i = 0; i < Lancamentos.length; i++) {
        if (Lancamentos[i].tipo === 'E') {

          if (Lancamentos[i].valor) { global.gSubTotal = global.gSubTotal + (realParaNumber(Lancamentos[i].valor)); }
          if ((Lancamentos[i].idagenda) && (Lancamentos[i].valor)) { global.gSubTotalAgendas = global.gSubTotalAgendas + (realParaNumber(Lancamentos[i].valor)); }
          if ((Lancamentos[i].idagenda) && (Lancamentos[i].cash)) { global.gSubTotalAgendasCash = global.gSubTotalAgendasCash + (realParaNumber(Lancamentos[i].cash)); }
          if ((Lancamentos[i].idagenda) && (Lancamentos[i].cc)) { global.gSubTotalAgendasCC = global.gSubTotalAgendasCC + (realParaNumber(Lancamentos[i].cc)); }
          if ((Lancamentos[i].idagenda) && (Lancamentos[i].pix)) { global.gSubTotalAgendasPix = global.gSubTotalAgendasPix + (realParaNumber(Lancamentos[i].pix)); }
          if ((Lancamentos[i].idagenda) && (Lancamentos[i].creditoavista)) { global.gSubTotalAgendasCartao = global.gSubTotalAgendasCartao + (realParaNumber(Lancamentos[i].creditoavista)); }
          if ((Lancamentos[i].idagenda) && (Lancamentos[i].creditoparc)) { global.gSubTotalAgendasCartao = global.gSubTotalAgendasCartao + (realParaNumber(Lancamentos[i].creditoparc)); }
          if ((Lancamentos[i].idagenda) && (Lancamentos[i].debito)) { global.gSubTotalAgendasCartao = global.gSubTotalAgendasCartao + (realParaNumber(Lancamentos[i].debito)); }
          if (Lancamentos[i].cash) { global.gCash = global.gCash + ((realParaNumber(Lancamentos[i].cash)-realParaNumber(Lancamentos[i].troco))); }
          if (Lancamentos[i].debito) { global.gDebito = global.gDebito + (realParaNumber(Lancamentos[i].debito)); }
          if (Lancamentos[i].creditoavista) { global.gCCv = global.gCCv + (realParaNumber(Lancamentos[i].creditoavista)); }
          if (Lancamentos[i].creditoparc) { global.gCCp = global.gCCp + (realParaNumber(Lancamentos[i].creditoparc)); }
          if (Lancamentos[i].pix) { global.gPix = global.gPix + (realParaNumber(Lancamentos[i].pix)); }
          if (Lancamentos[i].cc) { global.gCC = global.gCC + (realParaNumber(Lancamentos[i].cc)); }

        }

        if (Lancamentos[i].tipo === 'S') {

          if (Lancamentos[i].cash) { global.gCash = global.gCash - (realParaNumber(Lancamentos[i].cash)); }

        }

        if (Lancamentos[i].tipo === 'V') {

          if (Lancamentos[i].cash) { global.gCash = global.gCash - (realParaNumber(Lancamentos[i].cash)); }
          if (Lancamentos[i].cash) { global.gSubTotalVales = global.gSubTotalVales + (realParaNumber(Lancamentos[i].cash)); }

        }

        if (Lancamentos[i].tipo === 'F') {

          if (Lancamentos[i].cash) { global.gCash = global.gCash - (realParaNumber(Lancamentos[i].cash)); }

        }

        if (Lancamentos[i].tipo === 'A') {

          if (Lancamentos[i].cash) { global.gCash = global.gCash + (realParaNumber(Lancamentos[i].cash)); }

        }

      }
      let einputTotal = document.getElementById('inputTotal');
      if (einputTotal) { einputTotal.value = global.gSubTotal.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }); }

      let einputTotalAgendas = document.getElementById('inputTotalagendas');
      if (einputTotalAgendas) { einputTotalAgendas.value = global.gSubTotalAgendas.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }); }      
      let einputTotalAgendasCash = document.getElementById('inputTotalagendascash');
      if (einputTotalAgendasCash) { einputTotalAgendasCash.value = global.gSubTotalAgendasCash.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }); }      
      let einputTotalAgendasPix = document.getElementById('inputTotalagendaspix');
      if (einputTotalAgendasPix) { einputTotalAgendasPix.value = global.gSubTotalAgendasPix.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }); }      
      let einputTotalAgendasCartao = document.getElementById('inputTotalagendascartao');
      if (einputTotalAgendasCartao) { einputTotalAgendasCartao.value = global.gSubTotalAgendasCartao.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }); }      
      let einputTotalAgendasCC = document.getElementById('inputTotalagendascc');
      if (einputTotalAgendasCC) { einputTotalAgendasCC.value = global.gSubTotalAgendasCC.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }); }      
      let einputTotalVales = document.getElementById('inputTotalvales');
      if (einputTotalVales) { einputTotalVales.value = global.gSubTotalVales.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }); }      
      

      let einputCash = document.getElementById('inputCash');
      if (einputCash) { einputCash.value = global.gCash.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }); }
      let einputDebito = document.getElementById('inputDebito');
      if (einputDebito) { einputDebito.value = global.gDebito.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }); }
      let einputCCv = document.getElementById('inputCCv');
      if (einputCCv) { einputCCv.value = global.gCCv.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }); }
      let einputCCp = document.getElementById('inputCCp');
      if (einputCCp) { einputCCp.value = global.gCCp.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }); }
      let einputPix = document.getElementById('inputPix');
      if (einputPix) { einputPix.value = global.gPix.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }); }
      let einputCC = document.getElementById('inputCC');
      if (einputCC) { einputCC.value = global.gCC.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }); }

      let eimgloadingReactTabulatorCxMov = document.getElementById('imgloadingReactTabulatorCxMov');
      if (eimgloadingReactTabulatorCxMov) { eimgloadingReactTabulatorCxMov.style.display = 'none'; }

    }

    /* 
        let eimgloadingReactTabulatorCxMov = document.getElementById('imgloadingReactTabulatorCxMov');
        if (eimgloadingReactTabulatorCxMov) {
          eimgloadingReactTabulatorCxMov.style.display = 'none';
        }
    
        let edivReactTabulatorCxMov = document.getElementById('divReactTabulatorCxMov');
        if (edivReactTabulatorCxMov) {
          edivReactTabulatorCxMov.style.display = '';
        }
    
        btnFPGresetAll();
        global.gSubTotal = 0;
        var i
        if (Lancamentos) {
    
          for (i = 0; i < Lancamentos.length; i++) {
    
            global.gSubTotal = global.gSubTotal + (realParaNumber(Lancamentos[i].valor) * (realParaNumber(Lancamentos[i].qtd)));
    
          }
          let edivFormadePG = document.getElementById('divFormadePG');
          if (edivFormadePG) { edivFormadePG.style.display = ''; }
    
          let einputVConta = document.getElementById('inputVConta');
          let eibtnPgConta = document.getElementById('btnPgConta');
          if (Lancamentos.length > 1) {
            einputVConta.disabled = true;
            eibtnPgConta.disabled = true;
          } else {
            einputVConta.disabled = false;
            eibtnPgConta.disabled = false;
    
          }
    
    
    
        } else {
          let edivFormadePG = document.getElementById('divFormadePG');
          if (edivFormadePG) { edivFormadePG.style.display = 'none'; }
    
        }
        let einputTotal = document.getElementById('inputTotal');
        if (einputTotal) { einputTotal.value = global.gSubTotal.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }); } */
    //cl("global.gSubTotal", global.gSubTotal)
    //cl("Lancamentos mudou", Lancamentos)

  }, [Lancamentos])

  useEffect(() => {

    if (isFirstRunOpenCaixa.current) {
      isFirstRunOpenCaixa.current = false;
      //cl("FirstRunDados false")
      return;
    }
    let ignore = false;

    if (global.gOpencaixa === 0) {

      //cl("openCaixa", openCaixa);
      //let iopen = dateFormat(Date.parse(openCaixa.open), "yyyy-mm-dd HH:MM:ss");
      let iopen = moment(openCaixa.open).format("YYYY-MM-DD");
      let itroco = realParaNumber(openCaixa.troco);
      //cl("iopen", iopen);
      //cl('itroco', itroco);

      async function fetchdata() {
        var bodyFormData = new FormData();
        bodyFormData.set('apikey', '$#T#@!M%T@$MG@$OJG48ugyf987nszovhunfc4');
        bodyFormData.set('open', iopen);
        bodyFormData.set('troco', itroco);
        bodyFormData.set('user', global.gIdUser);

        const response = await requisitarCaixaSeguro('OpenCaixa.php',bodyFormData);
        //cl("response",response);
        if (response['data'] === 'caixa aberto ou já existe') {
          modalBase("Atenção", "O Caixa esta aberto ou Já existe caixa fechado para esta data !");
          //window.alert('O Caixa esta aberto ou Já existe caixa fechado para esta data !')
          return
        }
        //setrepCaixaOpen(response);

        setAtu({ '0': '0' });
        global.gOpencaixa = 1;
        if (!ignore) {

          let eleLoading = document.getElementById('divLoad');
          if (eleLoading) { eleLoading.style.display = 'none'; };
        }
      }


      fetchdata().catch(exibirErroCaixa);
    }
    return () => { ignore = true };

  }, [openCaixa])


  useEffect(() => {

    if (repCaixaOpen['data']) {
      let epanelCxOpen = document.getElementById('panelCxOpen');
      if (epanelCxOpen) { epanelCxOpen.style.display = ''; }
      let epanelCxClose = document.getElementById('panelCxClose');
      if (epanelCxClose) { epanelCxClose.style.display = 'none'; }
      let etituloCxOpen = document.getElementById('tituloCxOpen');
      let epanelMovresumo = document.getElementById('panelMovresumo');
      if (epanelMovresumo) { epanelMovresumo.style.display = ''; }
      let epanelMovaction = document.getElementById('panelMovaction');
      if (epanelMovaction) { epanelMovaction.style.display = ''; }
      let resp = repCaixaOpen['data'][0];
      if (etituloCxOpen) { etituloCxOpen.innerHTML = '>>> Caixa Aberto - ' + moment(resp.open).format("DD/MM/YYYY") + ' - ' + moment(resp.open).format("dddd, DD [de] MMMM YYYY") }
      //setAtuLanc({ '0': '0' });
      global.gCaixaId = resp['id'];
      if (global.gAlertaCaixaMov === 0) {


        let current = moment().startOf('day');
        //cl("dif",moment.duration(moment(resp.open).diff(current)).asDays())
        if ((moment.duration(moment(resp.open).diff(current)).asDays()) < 0) {
          let f1 = "O Caixa Aberto (" + moment(resp.open).format("DD/MM/YYYY") + ") não esta na data de hoje ! (" + moment(current).format("DD/MM/YYYY") + ")";
          modalBase("Atenção", f1, "Revise e feche o caixa logo!")
          global.gAlertaCaixaMov = 1;
        }
      }


      //global.gOpencaixa = 1;

      //cl("ok repCaixaOpen data", repCaixaOpen);

      setAtuLancamentos({ 'caixa': global.gCaixaId })
      setAtuRelComiss({ 'caixa': global.gCaixaId })
      setAtuRelComissResumo({ 'caixa': global.gCaixaId })


    } else {
      //  cl("no repCaixaOpen data");
      let epanelCxClose = document.getElementById('panelCxClose');
      if (epanelCxClose) { epanelCxClose.style.display = ''; }
      let epanelCxOpen = document.getElementById('panelCxOpen');
      if (epanelCxOpen) { epanelCxOpen.style.display = 'none'; }
      let epanelMovresumo = document.getElementById('panelMovresumo');
      if (epanelMovresumo) { epanelMovresumo.style.display = 'none'; }
      let epanelMovaction = document.getElementById('panelMovaction');
      if (epanelMovaction) { epanelMovaction.style.display = 'none'; }
      global.gOpencaixa = 0;
      //window.open("/caixa", "_self");

    }


  }, [repCaixaOpen])


  useEffect(() => {
    /*     if (isFirstRunDados.current) {
          isFirstRunDados.current = false;
          //cl("FirstRunDados false")
          return;
        } */
    let ignore = false;

    async function fetchdata() {
      var bodyFormData = new FormData();
      bodyFormData.set('apikey', '$#T#@!M%T@$MG@$OJG48ugyf987nszovhunfc4');
      //bodyFormData.set('numcontr', gGlobal.gContrato);
      //bodyFormData.set('comp', 1);
      //bodyFormData.set('password', password);
      //bodyFormData.append('password', 'senha');
      const urlfull = apiUrl('listaCaixa.php');
      //cl("urlfull",urlfull);
      const response = await axios({
        method: 'post',
        url: urlfull,
        data: bodyFormData,
        config: { headers: { 'Content-Type': 'multipart/form-data' } }
      })
      //cl("response",response);
      setrepCaixaOpen(response);
      if (!ignore) {
        const redata = [{}];
        const redata2 = response['data'];
        if (redata2) {
          setrep(redata2);
          //cl("redata2",redata2);
        } else {
          setrep(redata);
          //cl("redata",redata);
        }
        //const redata = [{prop:"1210140551/19", contr:"C1210140551/19",cliente:"CONDOMINIO EDIFICIO VILA CAROLINA",tipo:"Auditoria de Gestão",status:"Editando"}];



        let eleLoading = document.getElementById('divLoad');
        if (eleLoading) { eleLoading.style.display = 'none'; };
      }
    }
    fetchdata();
    //cl('gcontrato', gGlobal.gContrato);

    return () => { ignore = true };
  }, [Atu])

  useEffect(() => {
    /*     if (isFirstRunAtuLanc.current) {
          isFirstRunAtuLanc.current = false;
          //cl("FirstRunDados false")
          return;
        } */
    let ignore = false;

    async function fetchdata() {
      var bodyFormData = new FormData();
      bodyFormData.set('apikey', '$#T#@!M%T@$MG@$OJG48ugyf987nszovhunfc4');

      const urlfull = apiUrl('listaFecha.php');
      //cl("urlfull",urlfull);
      const response = await axios({
        method: 'post',
        url: urlfull,
        data: bodyFormData,
        config: { headers: { 'Content-Type': 'multipart/form-data' } }
      })
      //cl("response",response);
      //setrepCaixaOpen(response);
      setLanc(response['data']);
      setAtu({ '0': '0' });
      if (!ignore) {
        /*         const redata = [{}];
                const redata2 = response['data'];
                if (redata2) {
                  setrep(redata2);
                } else {
                  setrep(redata);
                } */
        //const redata = [{prop:"1210140551/19", contr:"C1210140551/19",cliente:"CONDOMINIO EDIFICIO VILA CAROLINA",tipo:"Auditoria de Gestão",status:"Editando"}];
        //cl(redata);


        let eleLoading = document.getElementById('divLoad');
        if (eleLoading) { eleLoading.style.display = 'none'; };
      }
    }


    fetchdata();

    return () => { ignore = true };
  }, [AtuLanc])

  const ref = null;
  function paramLookup() {
    //do some processing and return the param object
    return { param1: "green" };
  }

  const colunaCorrigirRecebimento = {
    title: '<i class="fas fa-tools" title="Ações"></i>', width: 82, minWidth: 82, hozAlign: 'center', headerSort: false, responsive: 0,
    formatter: cell => {
      const r=cell.getRow().getData();
      if (r.historico_credito || String(global.gTipoUser)!=='A') return '';
      if(String(r.ref||'').startsWith('CREDITO_PREPAGO_'))return '';
      const agenda=String(r.idagenda||'').trim();
      const acoes={editar:'',profissional:'',reverter:''};
      if (agenda && r.tipo==='E') {
        if (/^\d+$/.test(agenda)&&realParaNumber(r.pre_pago||'0')===0&&realParaNumber(r.permuta||'0')===0) acoes.editar=iconeAcao('pagamento','Corrigir pagamento','fas fa-edit');
        acoes.profissional=iconeAcao('transferencia','Transferir profissional','fas fa-user-edit');
        if (Number(global.gIdUser)===1 && /^\d+(?:,\d+)*$/.test(agenda)) {
          acoes.reverter=iconeAcao('adminagenda','Reverter ou cancelar atendimento pago','fas fa-undo');
        }
      } else if (!agenda && ['E','S'].includes(r.tipo) && r.status==='inicial') {
        acoes.editar=iconeAcao('manual','Editar/cancelar lançamento manual','fas fa-edit');
      }
      if (!Object.values(acoes).some(Boolean)) return '';
      return formatarAcoesCaixa(acoes);
    },
    cellClick: (e,cell) => {
      const r=cell.getRow().getData();
      const alvo=e.target && e.target.closest ? e.target.closest('[data-acao]') : null;
      if (!alvo) { if (e.stopPropagation) e.stopPropagation(); abrirDetalheMovimento(r); return; }
      if (e.stopPropagation) e.stopPropagation();
      const acao=alvo.getAttribute('data-acao');
      if (acao==='pagamento') abrirCorrecaoMov(r);
      else if (acao==='transferencia') abrirTransferencia(r);
      else if (acao==='manual') abrirMovimentoManual(r);
      else if (acao==='adminagenda') abrirAdminAgenda(r);
    }
  };
  const columns = [
    colunaCorrigirRecebimento,
    //{ formatter: "responsiveCollapse", headerSort: false, width: 30, minWidth: 30, align: "center", resizable: false, responsive: 0 },
    // // { title: 'Data', field: 'createdAt' ,align: 'center', formatter: DataFormatter, width: 80, responsive:0, headerFilter:"input"},
    //{ title: 'Chave', field: 'chave', align: 'center', width: 40, visible: false, responsive: 0 },
    { title: 'Id', field: 'id', hozAlign: 'center', width: 54, visible: true, headerSort: false, responsive: 0, headerSortStartingDir: "asc", formatter: cell=>idHistoricoCredito(cell,formatarIdMovimentoCaixa), cellClick: (e,cell) => { if (e.stopPropagation) e.stopPropagation(); abrirDetalheMovimento(cell.getRow().getData()); } },
    /* { title: 'Caixa', field: 'open', hozAlign: 'center', width: 120, visible: true, responsive: 0, headerSort: false }, */
    { title: 'Descrição', field: 'descricao', formatter: descricaoHistoricoCredito, variableHeight: true, hozAlign: "left", width: 250, responsive: 0, headerSort: false },
    { title: 'Op', field: 'tipo', hozAlign: "center", width: 10, responsive: 0, headerSort: false, },
    { title: 'Total R$', field: 'valor', hozAlign: "right", width: 70, responsive: 0, headerSort: false },
    colunaHistoricosCredito(colunaFormasPagamento()),

    /*       {
      title: 'Comis.(%)', field: 'porc', hozAlign: "center", width: 100, responsive: 0, headerSort: false, sorter: "string", headerSortStartingDir: "desc", formatter: function (cell, formatterParams, onRendered) {
        
        let textoAjustado = cell.getValue();
        
        return textoAjustado + " %";
      }
    }, */
    /*  { title: 'Editar', formatter: editIcon, width: 70, headerSort: false, responsive: 0, hozAlign: "center", cellClick: function (e, cell) { if (cell.getRow().getData().status == 'finalizado') { editLanc((cell.getRow().getData().id), (cell.getRow().getData().valor), (cell.getRow().getData().qtd), (cell.getRow().getData().descricao), (cell.getRow().getData().idagenda)) } } }, */
  ];
  const columnsRel = [
    //{ formatter: "responsiveCollapse", headerSort: false, width: 30, minWidth: 30, align: "center", resizable: false, responsive: 0 },
    // // { title: 'Data', field: 'createdAt' ,align: 'center', formatter: DataFormatter, width: 80, responsive:0, headerFilter:"input"},
    //{ title: 'Chave', field: 'chave', align: 'center', width: 40, visible: false, responsive: 0 },
    { title: 'Id', field: 'id', hozAlign: 'center', width: 54, visible: true, headerSort: false, responsive: 0, headerSortStartingDir: "asc", formatter: (cell) => {
      const id = idAgendaApontamento(cell.getRow().getData());
      if (!id) return '-';
      const botao = document.createElement('button');
      botao.type = 'button';
      botao.className = 'mbhair-id-agenda-apontamento';
      botao.textContent = String(id);
      botao.title = 'Abrir detalhamento completo do agendamento #' + id;
      return botao;
    }, cellClick: (e,cell) => {
      e.stopPropagation();
      const id = idAgendaApontamento(cell.getRow().getData());
      if (id) setAgendaDetalheId(id);
    } },
    { title: 'Agenda', field: 'agenda', align: 'center', width: 90, responsive: 0, formatter: formatData },
    /* { title: 'Caixa', field: 'open', hozAlign: 'center', width: 120, visible: true, responsive: 0, headerSort: false }, */
    { title: 'Descrição', field: 'cliente', hozAlign: "left", width: 200, responsive: 0, headerSort: false },
    /* { title: 'Profissional', field: 'prof', hozAlign: "left", width: 125, responsive: 0, headerSort: false }, */
    { title: 'Serviço', field: 'serv', hozAlign: "left", width: 200, responsive: 0, headerSort: false },
    { title: 'Total R$', field: 'valor', hozAlign: "right", width: 70, responsive: 0, headerSort: false },
    { title: 'Auxiliar R$', field: 'flex_receber', hozAlign: 'right', width: 88, responsive: 0, headerSort: false, formatter: function(cell) { const row = cell.getRow().getData(); const nome = String(row.auxiliar || '-'); const valor = String(cell.getValue() || '0,00'); const esc = v => v.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\"/g, '&quot;').replace(/'/g, '&#39;'); return '<span title=\"' + esc(nome) + '\">' + esc(valor) + '</span>'; } },
    { title: 'Insumos R$', field: 'insumos', hozAlign: "right", width: 80, responsive: 0, headerSort: false },
    { title: 'Getnet %', field: 'getnet', hozAlign: "center", width: 80, responsive: 0, headerSort: false },
    { title: 'Antecip %', field: 'antecip', hozAlign: "center", width: 80, responsive: 0, headerSort: false },
    { title: '%', field: 'porc', hozAlign: "right", width: 40, responsive: 0, headerSort: false },
    { title: 'Receber', field: 'receber', hozAlign: "right", width: 90, responsive: 0, headerSort: false, bottomCalc: adultCalc },
    /*       {
      title: 'Comis.(%)', field: 'porc', hozAlign: "center", width: 100, responsive: 0, headerSort: false, sorter: "string", headerSortStartingDir: "desc", formatter: function (cell, formatterParams, onRendered) {
        
        let textoAjustado = cell.getValue();
        
        return textoAjustado + " %";
      }
    }, */
    /*  { title: 'Editar', formatter: editIcon, width: 70, headerSort: false, responsive: 0, hozAlign: "center", cellClick: function (e, cell) { if (cell.getRow().getData().status == 'finalizado') { editLanc((cell.getRow().getData().id), (cell.getRow().getData().valor), (cell.getRow().getData().qtd), (cell.getRow().getData().descricao), (cell.getRow().getData().idagenda)) } } }, */
  ];
  const columnsRelResumo = [
    //{ formatter: "responsiveCollapse", headerSort: false, width: 30, minWidth: 30, align: "center", resizable: false, responsive: 0 },
    // // { title: 'Data', field: 'createdAt' ,align: 'center', formatter: DataFormatter, width: 80, responsive:0, headerFilter:"input"},
    //{ title: 'Chave', field: 'chave', align: 'center', width: 40, visible: false, responsive: 0 },
    //    { title: 'Id', field: 'id', hozAlign: 'center', width: 10, visible: true, headerSort: false, responsive: 0, headerSortStartingDir: "asc" },
    //    { title: 'Agenda', field: 'agenda' ,align: 'center', width: 90, responsive:0, formatter:formatData},
    /* { title: 'Caixa', field: 'open', hozAlign: 'center', width: 120, visible: true, responsive: 0, headerSort: false }, */
    //    { title: 'Descrição', field: 'cliente', hozAlign: "left", width: 250, responsive: 0, headerSort: false },
    { title: 'Profissional', field: 'prof', hozAlign: "left", width: 125, responsive: 0, headerSort: false },
    //    { title: 'Serviço', field: 'serv', hozAlign: "left", width: 150, responsive: 0, headerSort: false },
    //    { title: 'Total R$', field: 'valor', hozAlign: "right", width: 70, responsive: 0, headerSort: false },
    //    { title: 'Insumos R$', field: 'insumos', hozAlign: "right", width: 80, responsive: 0, headerSort: false },
    //    { title: 'Getnet %', field: 'getnet', hozAlign: "center", width: 80, responsive: 0, headerSort: false },
    //    { title: 'Antecip %', field: 'antecip', hozAlign: "center", width: 80, responsive: 0, headerSort: false },
    //    { title: '%', field: 'porc', hozAlign: "right", width: 40, responsive: 0, headerSort: false },
    { title: 'à Receber R$', field: 'receber', hozAlign: "right", width: 90, responsive: 0, headerSort: false },
    //{ title: 'Classificação', field: 'star', hozAlign: "right", width: 90, responsive: 0, headerSort: false, formatter:'star', formatterParams:{stars:5} },
    { title: 'Vendas', field: 'progress', hozAlign: "left", width: 90, responsive: 0, headerSort: false, formatter:'progress', formatterParams:{color:["rgb(255,0,0)", "#38b544f5","#00fd00" ]} },
    { title: 'Rentabilidade', field: 'rentprogress', hozAlign: "left", width: 90, responsive: 0, headerSort: false, formatter:'progress', formatterParams:{color:["rgb(255,0,0)", "#38b544f5","#00fd00" ]} }

    /*       {
      title: 'Comis.(%)', field: 'porc', hozAlign: "center", width: 100, responsive: 0, headerSort: false, sorter: "string", headerSortStartingDir: "desc", formatter: function (cell, formatterParams, onRendered) {
        
        let textoAjustado = cell.getValue();
        
        return textoAjustado + " %";
      }
    }, */
    /*  { title: 'Editar', formatter: editIcon, width: 70, headerSort: false, responsive: 0, hozAlign: "center", cellClick: function (e, cell) { if (cell.getRow().getData().status == 'finalizado') { editLanc((cell.getRow().getData().id), (cell.getRow().getData().valor), (cell.getRow().getData().qtd), (cell.getRow().getData().descricao), (cell.getRow().getData().idagenda)) } } }, */
  ];





  const movimentoDestino = Number(new URLSearchParams(window.location.search).get('movimento_id') || 0);
  const destacarMovimento = row => {
    if (!movimentoDestino || Number(row.getData().id) !== movimentoDestino) return;
    const el = row.getElement();
    el.classList.add('mbhair-mov-alvo');
    if (!focoMovimentoRef.current) {
      focoMovimentoRef.current=true;
      setTimeout(() => {if(el.isConnected)el.scrollIntoView({behavior:'auto',block:'center'});},150);
    }
  };
  const options = {
    rowFormatter: destacarMovimento,
    //autoResize:false,
    //height: 125,
    // movableRows: true,
    clipboard: true,
    //resizableRows:true,
    //invalidOptionWarnings: false,
    responsiveLayoutCollapseStartOpen: false,
    //groupBy:"origem",
    //groupValues:["APP_Teste"],
    //selectable:1,
    //selectablePersistence:false,
    responsiveLayout: "collapse",
    /*     initialSort: [
          { column: "id", dir: "asc" }, //sort by this first
        ] */
    // pagination:"local",
    // paginationSize:12,
    // paginationSizeSelector:[10, 25, 50, 100],

  };

  const optionsRel = {
    //autoResize:false,
    //height: 125,
    // movableRows: true,
    clipboard: true,
    groupBy: "prof",
    groupHeader: function (value, count, data, group) {
      //value - the value all members of this group share
      //count - the number of rows in this group
      //data - an array of all the row data objects in this group
      //group - the group component for the group

      if (count <= 1) {

        return value + "<span style='color:#d00; margin-left:10px;'>(" + count + " item)</span>";
      } else {

        return value + "<span style='color:#d00; margin-left:10px;'>(" + count + " items)</span>";
      }
    },
    //resizableRows:true,
    //invalidOptionWarnings: false,
    responsiveLayoutCollapseStartOpen: false,
    //groupBy:"origem",
    //groupValues:"prof",
    //selectable:1,
    //selectablePersistence:false,
    responsiveLayout: "collapse",
    /*     initialSort: [
          { column: "id", dir: "asc" }, //sort by this first
        ] */
    // pagination:"local",
    // paginationSize:12,
    // paginationSizeSelector:[10, 25, 50, 100],

  };

  const optionsRelResumo = {
    //autoResize:false,
    //height: 125,
    // movableRows: true,
    clipboard: true,
    /*     groupBy:"prof",
        groupHeader:function(value, count, data, group){
          //value - the value all members of this group share
          //count - the number of rows in this group
          //data - an array of all the row data objects in this group
          //group - the group component for the group
      
          if (count <= 1){
    
            return value + "<span style='color:#d00; margin-left:10px;'>(" + count + " item)</span>";
          } else {
            
            return value + "<span style='color:#d00; margin-left:10px;'>(" + count + " items)</span>";
          }
      }, */
    //resizableRows:true,
    //invalidOptionWarnings: false,
    responsiveLayoutCollapseStartOpen: false,
    //groupBy:"origem",
    //groupValues:"prof",
    //selectable:1,
    //selectablePersistence:false,
    responsiveLayout: "collapse",
    /*     initialSort: [
          { column: "id", dir: "asc" }, //sort by this first
        ] */
    // pagination:"local",
    // paginationSize:12,
    // paginationSizeSelector:[10, 25, 50, 100],

  };


  function whatsappweb(nome, fone) {
    let link = "https://api.whatsapp.com/send?phone=55" + fone.replace(/_|-| |\(|\)/g, '') + "&text=Olá " + nome
    window.open(link, '_blank');

  }

  function novoCadastro(params) {


    let etituloContr = document.getElementById('tituloContr');
    etituloContr.innerHTML = "Novo Cadastro ..."

    global.gLog = [];


    let ele = document.getElementById('panelActions');
    ele.style.display = '';

    let eQtdInicial = document.getElementById('QtdInicial');
    eQtdInicial.style.display = '';

    let einputCodBarras = document.getElementById('inputCodBarras');
    einputCodBarras.value = '';
    einputCodBarras.focus();

    let elenome = document.getElementById('inputNome');
    elenome.value = '';
    elenome.disabled = false;

    let einputGrupo = document.getElementById('inputGrupo');
    einputGrupo.value = '';


    let einputValorCusto = document.getElementById('inputValorCusto');
    einputValorCusto.value = '';

    let einputValor = document.getElementById('inputValor');
    einputValor.value = '';

    let einputUnidade = document.getElementById('inputUnidade');
    einputUnidade.value = '';

    let einputQtdMin = document.getElementById('inputQtdMin');
    einputQtdMin.value = '';


    let einputPorc = document.getElementById('inputPorc');
    einputPorc.value = '';

  }


  function editCadastro(params) {

    let eQtdInicial = document.getElementById('QtdInicial');
    eQtdInicial.style.display = 'none';

    let ele = document.getElementById('panelActions');
    ele.style.display = '';

    let etituloContr = document.getElementById('tituloContr');
    etituloContr.innerHTML = "Editar Produto ..."

    var arrFound = rep.filter(function (item, num) {
      return item.id === params;
    });

    global.gLog = arrFound[0];
    //cl("global.gLog", global.gLog);
    let dtfinal = '';
    /*    if(arrFound[0].dtnasc){
          
          let dt = arrFound[0].dtnasc.split("/");
          dtfinal = ''+dt[2]+'-'+dt[1]+'-'+dt[0]+'';
        } else {
          dtfinal = '';
        } */

    //cl(dtfinal);

    let eleCodBarras = document.getElementById('inputCodBarras');
    eleCodBarras.value = arrFound[0].ean;

    let elenome = document.getElementById('inputNome');
    elenome.value = arrFound[0].descricao;
    //elenome.disabled = true;

    let einputValor = document.getElementById('inputValor');
    einputValor.value = arrFound[0].valor;

    let einputUnidade = document.getElementById('inputUnidade');
    einputUnidade.value = arrFound[0].unidade;

    let einputValorCusto = document.getElementById('inputValorCusto');
    einputValorCusto.value = arrFound[0].valor_custo;

    let einputQtdMin = document.getElementById('inputQtdMin');
    einputQtdMin.value = arrFound[0].estoque_min;

    let einputGrupo = document.getElementById('inputGrupo');
    einputGrupo.value = arrFound[0].grupo;

    let einputPorc = document.getElementById('inputPorc');
    einputPorc.value = parseFloat(arrFound[0].porc.replace(',', '.'));


    //validaFone();
    CalcSimule();


  }

  function editLanc(id, valor, qtd, descricao, idagenda) {


    // cl(id, valor, qtd);


    confirmAltLanc(id, valor, qtd, descricao, idagenda);

    let einputMQtd = document.getElementById('inputMQtd');
    einputMQtd.value = qtd;
    let einputMValor = document.getElementById('inputMValor');
    einputMValor.value = valor;
    /*       setEditLancamentos({
            id: 126,
            valor: "400,00",
            qtd: 1
          })
    
          setAtuLancamentos({ idagenda: global.gidAgenda }) */

  }

  function btnFinalizarPG(params) {

    let einputVCash = document.getElementById('inputVCash');
    let rVCash = realParaNumber(einputVCash.value);
    let einputVTroco = document.getElementById('inputVTroco');
    let rVTroco = realParaNumber(einputVTroco.value);
    let einputVCD = document.getElementById('inputVCD');
    let rVCD = realParaNumber(einputVCD.value);
    let einputVCC = document.getElementById('inputVCC');
    let rVCC = realParaNumber(einputVCC.value);
    let einputVCCx = document.getElementById('inputVCCx');
    let rVCCx = realParaNumber(einputVCCx.value);
    let einputVPix = document.getElementById('inputVPix');
    let rVPIX = realParaNumber(einputVPix.value);
    let einputVConta = document.getElementById('inputVConta');
    let rConta = realParaNumber(einputVConta.value);


    let somaFPG = rConta;
    somaFPG = somaFPG + rVCash;
    somaFPG = somaFPG + rVCD;
    somaFPG = somaFPG + rVCC;
    somaFPG = somaFPG + rVCCx;
    somaFPG = somaFPG + rVPIX;

    //cl("somaFPG",somaFPG);
    //cl("global.gSubTotal",somaFPG);

    let descricao = 'Pagamento - Agenda (' + LancSelected.toString() + ')';
    if ((global.gSubTotal === somaFPG) || (global.gSubTotal < somaFPG)) {



      confirmFinalizarPG(descricao, global.gSubTotal, rVCash, rVTroco, rVCD, rVCC, rVCCx, rVPIX, rConta);
    } else {
      //window.alert("A Soma das formas de Pagamento não confere, revise ou preencha!")
      modalBase("Atenção", "A Soma das formas de Pagamento não confere, revise ou preencha!");
    }





  }

  function confirmFinalizarPG(desc, rVTotal, rVCash, rVTroco, rVCD, rVCC, rVCCx, rVPIX, rConta) {
    confirmAlert({
      closeOnClickOutside: false,
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            {/* <h1>Deseja Deletar este registro ? {testeStr}</h1><br></br><br></br> */}
            <div className="modal-header">
              <h4 className="modal-title">Confirmação para Finalizar Pagamento</h4>
            </div>
            <div className="modal-body">
              <p>Após finalizar o Pagamento não será mais possível alterar!</p>
            </div>
            <div className="modal-body">
              <p>Tem Certeza ?</p>
            </div>
            <button className="btn bg-gradient-info btn-sm" onClick={onClose}>Não</button>
            <button
              className="btn bg-gradient-success btn-sm float-right"
              onClick={() => {

                setFinalizaPag({
                  cliente: '',
                  caixa: global.gCaixaId,
                  idagenda: LancSelected.toString(),
                  tipo: 'C',
                  desc: desc,
                  valor: rVTotal,
                  cash: rVCash,
                  troco: rVTroco,
                  debito: rVCD,
                  creditoavista: rVCC,
                  creditoparc: rVCCx,
                  pix: rVPIX,
                  cc: rConta
                })

                onClose();
              }}
            >
              Sim, finalizar!
            </button>
          </div>
        );
      }
    });
  }

  function confirmAltLanc(id, valor, qtd, descricao, idagenda) {
    //    var testeStr = 'Isso é um teste <<nome>>';
    //    testeStr = testeStr.replace('<<nome>>', nome)
    let lqtd = qtd;

    confirmAlert({
      closeOnClickOutside: false,
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            {/* <h1>Deseja Deletar este registro ? {testeStr}</h1><br></br><br></br> */}
            <div className="modal-header">
              <h4 className="modal-title">{descricao}</h4>
            </div>
            <div className="form-row">
              <div className="form-group col-md-6">
                <label htmlFor="lEmail3">Qtd.</label>
                <div className="input-group-prepend">
                  <input type="number" className="form-control" autocomplete="off" id="inputMQtd" />
                </div>
              </div>
              <div className="form-group col-md-6">
                <label htmlFor="lEmail3">Valor R$</label>
                <div className="input-group-prepend">
                  <input type="text" className="form-control" autocomplete="off" id="inputMValor" />
                </div>
              </div>
            </div>

            <button className="btn bg-gradient-info btn-sm" onClick={onClose}>Não</button>
            <button
              className="btn bg-gradient-danger btn-sm float-right"
              onClick={() => {
                let einputMValor = document.getElementById('inputMValor');
                let einputMQtd = document.getElementById('inputMQtd');


                setEditLancamentos({
                  id: id,
                  valor: realParaNumber(einputMValor.value),
                  qtd: einputMQtd.value,
                  idagenda: idagenda
                })

                onClose();
              }}
            >
              Sim
            </button>
          </div>
        );
      }
    });
  }

  function btnconfirmFechaCx(params) {

    confirmFechaCx();
    let einputCxTValor = document.getElementById('inputCxTValor');
    einputCxTValor.value = global.gCash.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });

  }

  function calcProxCx(vtotal, sangria) {

    let sang = realParaNumber(document.getElementById(sangria).value);
    let result = global.gCash - sang;
    if (result >= 0) {

      document.getElementById(vtotal).value = result.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
    } else {
      window.alert("O Valor da Sangria não pode ser maior que o Saldo Atual !");
      document.getElementById(sangria).value = global.gCash.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
      result = 0;
      document.getElementById(vtotal).value = result.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
    }

    cl(vtotal, sangria);

  }

  function confirmFechaCx(id, valor, qtd, descricao, idagenda) {
    //    var testeStr = 'Isso é um teste <<nome>>';
    //    testeStr = testeStr.replace('<<nome>>', nome)
    let lqtd = qtd;


    confirmAlert({
      closeOnClickOutside: false,
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            {/* <h1>Deseja Deletar este registro ? {testeStr}</h1><br></br><br></br> */}
            <div className="modal-header">
              <h4 className="modal-title">Fechamento de Caixa - Sangria</h4>
            </div>
            <div className="form-row">
              <div className="form-group col-md-4">
                <label htmlFor="lEmail3">Saldo Atual</label>
                <div className="input-group-prepend">
                  <input type="text" className="form-control" disabled autocomplete="off" id="inputCxTValor" />
                </div>
              </div>
              <div className="form-group col-md-4">
                <label htmlFor="lEmail3">Sangria</label>
                <div className="input-group-prepend">
                  <input type="text" className="form-control" onChange={() => calcProxCx('inputCxProx', 'inputCxSangria')} autocomplete="off" id="inputCxSangria" />
                </div>
              </div>
              <div className="form-group col-md-4">
                <label htmlFor="lEmail3">Próximo Caixa</label>
                <div className="input-group-prepend">
                  <input type="text" className="form-control" disabled autocomplete="off" id="inputCxProx" />
                </div>
              </div>
            </div>

            <button className="btn bg-gradient-info btn-sm" onClick={onClose}>Não</button>
            <button
              className="btn bg-gradient-danger btn-sm float-right"
              onClick={() => {
                let einputCxSangria = document.getElementById('inputCxSangria');
                let einputCxProx = document.getElementById('inputCxProx');

                if (!einputCxSangria.value) {
                  einputCxSangria.focus();
                  return
                }
                if (!einputCxProx.value) {
                  einputCxSangria.focus();
                  return
                }

                // return


                setFechaCaixa({
                  sangria: realParaNumber(einputCxSangria.value),
                  vfinal: realParaNumber(einputCxProx.value),
                })

                onClose();
              }}
            >
              Fechar Caixa
            </button>
          </div>
        );
      }
    });
  }

  function selectChange(params) {

    let einputMIdProf = document.getElementById('inputMIdProf');
    let einputMDtVenc = document.getElementById('inputMDtVenc');
    let eSelectTipo = document.getElementById('SelectTipo');
    let eSelectAcerto = document.getElementById('SelectAcerto');
    let eSelectFpg = document.getElementById('SelectFpg');
    cl("Profis",Profis)

    if (eSelectTipo.value === "V") {
      einputMIdProf.disabled = false;
      einputMDtVenc.disabled = false;
      eSelectAcerto.disabled = false;
      eSelectAcerto.focus();
      eSelectFpg.value = "cash";
      eSelectFpg.disabled = true;
      let k;
      let eSelectServ = document.getElementById('inputMIdProf');
      removeOptions(document.getElementById('inputMIdProf'));
      //cl(searchServicos)
      if(Profis.length > 1){
        let opt = document.createElement('option');
        opt.value = 0;
        opt.innerHTML = 'Selecione...';
        eSelectServ.appendChild(opt);
  
      }
      for (k = 0; k < Profis.length; k++) {
        let opt = document.createElement('option');
        opt.value = Profis[k].id;
        opt.innerHTML = Profis[k].name;
        eSelectServ.appendChild(opt);
      }
    } else {

      einputMIdProf.disabled = true;
      einputMDtVenc.disabled = true;
      eSelectFpg.disabled = false;
      eSelectAcerto.disabled = true;
    }

  }

  function selectProf(params) {
    let einputMDesc = document.getElementById('inputMDesc');
    let einputMIdProf = document.getElementById('inputMIdProf');

    einputMDesc.value = '(' + einputMIdProf.children[einputMIdProf.selectedIndex].textContent + ') VALE : ' + einputMDesc.textContent;

  }

  function removeOptions(selectElement) {
    var i, L = selectElement.options.length - 1;
    for (i = L; i >= 0; i--) {
      selectElement.remove(i);
    }
  }

  function abrirRecebimentoCC() {
    if (!Number(global.gCaixaId) || !Number(global.gIdUser)) {
      modalBase('Atenção', 'É necessário ter caixa aberto e usuário identificado.'); return;
    }
    confirmAlert({
      closeOnClickOutside: false,
      customUI: ({onClose}) => <RecebimentoCCModal
        caixa={global.gCaixaId} usuario={global.gIdUser}
        onClose={onClose}
        onSaved={r => {onClose();setAtuLancamentos({caixa:global.gCaixaId,alteracao:Date.now()});setAtuRelComiss({alteracao:Date.now()});modalBase('Recebimento registrado','Movimento CC nº '+r.id+'.');}}
      />
    });
  }

  function confirmMovCx(id, valor, qtd, descricao, idagenda) {
    //    var testeStr = 'Isso é um teste <<nome>>';
    //    testeStr = testeStr.replace('<<nome>>', nome)
    let lqtd = qtd;

    confirmAlert({
      closeOnClickOutside: false,
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            {/* <h1>Deseja Deletar este registro ? {testeStr}</h1><br></br><br></br> */}
            <div className="modal-header">
              <h4 className="modal-title">Lançamento manual/avulso no Caixa</h4>
            </div>
            <div className="form-row">
              <div className="form-group col-md-6">
                <label htmlFor="lEmail3">Tipo Movimentação</label>
                <div className="input-group-prepend">
                  <select className="form-control select2 select2-hidden-accessible" onChange={() => selectChange()} id="SelectTipo" tabIndex={-1} aria-hidden="true">
                    <option >selecione</option>
                    <option value="E">Entrada</option>
                    <option value="S">Saída</option>
                    <option value="V">Vale Profissional</option>
                  </select>
                </div>
              </div>
              <div className="form-group col-md-6">
                <label htmlFor="lEmail3">Acertar Caixa Automático</label>
                <div className="input-group-prepend">
                  <select className="form-control select2 select2-hidden-accessible " disabled id="SelectAcerto" tabIndex={-1} aria-hidden="true">
                    <option ></option>
                    <option value="1">Sim</option>
                    <option value="0">Não</option>
                  </select>
                </div>
              </div>              
            </div>
            <div className="form-row">
              <div className="form-group col-md-6">
                <label htmlFor="lEmail3">ID Prof.</label>
                <div className="input-group-prepend">
                  <select className="form-control select2 select2-hidden-accessible" onChange={() => selectProf()} disabled id="inputMIdProf" tabIndex={-1} aria-hidden="true">
                    <option >selecione</option>
                    <option value="6">César</option>
                    <option value="8">Gal</option>
                    <option value="2">Jorge</option>
                    <option value="9">Josy</option>
                    <option value="5">Júlio</option>
                    <option value="3">Kaká</option>
                    <option value="17">Lucas</option>
                    <option value="4">Rey</option>
                    <option value="18">Stefanny</option>
                    <option value="10">Val</option>
                    <option value="1">Márcio Bagagine</option>
                  </select>
                </div>
              </div>
              <div className="form-group col-md-6">
                <label htmlFor="lEmail3">Vencimento</label>
                <div className="input-group-prepend ">
                  <input type="date" className="form-control" disabled autocomplete="off" id="inputMDtVenc" />
                </div>
              </div>

            </div>
            <div className="form-row">
              <div className="form-group col-md-12">
                <label htmlFor="lEmail3">Descrição</label>
                <div className="input-group-prepend">
                  <input type="text" className="form-control" autocomplete="off" id="inputMDesc" />
                </div>
              </div>
            </div>
            <div className="form-row">
              <div className="form-group col-md-6">
                <label htmlFor="lEmail3">Valor R$</label>
                <div className="input-group-prepend">
                  <input type="text" className="form-control" autocomplete="off" id="inputMValor" />
                </div>
              </div>
              <div className="form-group col-md-6">
                <label htmlFor="lEmail3">Forma de Pagamento</label>
                <div className="input-group-prepend">
                  <select className="form-control select2 select2-hidden-accessible" id="SelectFpg" tabIndex={-1} aria-hidden="true">
                    <option >selecione</option>
                    <option value="cash">Dinheiro</option>
                    <option value="debito">Débito</option>
                    <option value="creditoavista">Credito à Vista</option>
                    <option value="creditoparc">Crédito Parc.</option>
                    <option value="pix">PIX</option>
                    <option value="cc">CC</option>
                  </select>
                </div>
              </div>

            </div>

            <button className="btn bg-gradient-info btn-sm" onClick={onClose}>Cancelar</button>
            <button
              className="btn bg-gradient-danger btn-sm float-right"
              onClick={() => {
                let eSelectTipo = document.getElementById('SelectTipo');
                let eSelectAcerto = document.getElementById('SelectAcerto');
                let eSelectFpg = document.getElementById('SelectFpg');
                let einputMValor = document.getElementById('inputMValor');
                let einputMDesc = document.getElementById('inputMDesc');
                let einputMIdProf = document.getElementById('inputMIdProf');
                let einputMDtVenc = document.getElementById('inputMDtVenc');

                if (eSelectTipo.value === 'selecione') {
                  eSelectTipo.focus();
                  return
                }
                if ((eSelectTipo.value === 'V') && (eSelectAcerto.value === '')) {
                  eSelectAcerto.focus();
                  return
                }
                if ((eSelectTipo.value === 'V') && (!einputMIdProf.value)) {
                  einputMIdProf.focus();
                  return
                }
                if ((eSelectTipo.value === 'V') && (!einputMDtVenc.value)) {
                  einputMDtVenc.focus();
                  return
                }

                if (!einputMDesc.value) {
                  einputMDesc.focus();
                  return
                }

                if (!einputMValor.value) {
                  einputMValor.focus();
                  return
                }

                if (eSelectFpg.value === 'selecione') {
                  eSelectFpg.focus();
                  return
                }

                //return


                setAddLancManual({
                  tipo: eSelectTipo.value,
                  desc: einputMDesc.value,
                  valor: realParaNumber(einputMValor.value),
                  idprof: einputMIdProf.value,
                  Fpg: eSelectFpg.value,
                  dtvenc: einputMDtVenc.value,
                  acerto: eSelectAcerto.value
                })

                onClose();
              }}
            >
              Lançar
            </button>
          </div>
        );
      }
    });
  }


  function realParaNumber(texto,ref) {
    //cl("realParaNumber",texto,ref)
    if (texto === '') {
      return 0
    }
    var compativelComParseFloat = texto.replace(/R|\$|\./g, '');
    // //cl("texto R$",compativelComParseFloat);
    compativelComParseFloat = compativelComParseFloat.replace(/,/g, '.');
    ////cl("texto ,.",compativelComParseFloat);
    var valor = parseFloat(compativelComParseFloat);
    //cl("valor",valor);

    return valor;
  }

  function ajustaInputMoney(params) {

    let eleVUnit = document.getElementById('inputValorTroco');
    let Vunit = realParaNumber(eleVUnit.value);
    eleVUnit.value = Vunit.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });

  }

  function CalcSimule(params) {

    /*     var iNf_valor = document.getElementById("inputNf_valor");
        let V_Nf_valor = realParaNumber(iNf_valor.value);
        if (V_Nf_valor) { iNf_valor.value = V_Nf_valor.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }); } */

    var iVlr_pago = document.getElementById("inputValor");
    let V_pago = realParaNumber(iVlr_pago.value);
    if (V_pago) { iVlr_pago.value = V_pago.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }); }
    /* 
        var iDif = document.getElementById("inputDif");
        let V_dif = realParaNumber(iDif.value);
        if (V_dif) { iDif.value = V_dif.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }); } */

    /*     var iPcc = document.getElementById("inputPcc");
        let V_Pcc = realParaNumber(iPcc.value);
        if (V_Pcc) { iPcc.value = V_Pcc.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }); } */

    /*     if ((iNf_valor.disabled === false) && (iVlr_pago.disabled === false) && (iDif.disabled === false)) {
          V_dif = V_pago - V_Nf_valor;
          if (V_dif > 0) {
            iDif.value = V_dif.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
          }
        } */
    /* 
        if ((iNf_valor.disabled === false) && (iPcc.disabled === false)) {
          V_Pcc = V_Nf_valor * 0.045;
          if (V_Pcc > 0) {
            iPcc.value = V_Pcc.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
          }
        } */




  }

  function validaOpenCaixa(params) {

    let einputDtCx = document.getElementById('inputDtCx');
    if (!einputDtCx.value) {
      window.alert('Selecione a Data de Abertura !!!')
      einputDtCx.focus();
      return
    };





    modalCaixaOpen(document.getElementById('inputDtCx').value, document.getElementById('inputValorTroco').value);

  }

  function modalBase(h1, p, p2, focus, inputquery) {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            {/* <h1>Deseja Deletar este registro ? {testeStr}</h1><br></br><br></br> */}
            <div className="modal-header">
              <h4 className="modal-title">{h1}</h4>
            </div>
            <div className="modal-body">
              <p>{p}</p>
            </div>
            <div className="modal-body">
              <p>{p2}</p>
            </div>
            {/* <button className="btn bg-gradient-info btn-sm" onClick={onClose}>Não</button> */}
            <button id="btnModal"
              className="btn bg-gradient-info float-right"
              onClick={() => {
                if (focus) {
                  document.getElementById(focus).focus();
                  // cl("focus")
                }
                if (inputquery) {
                  let inputM = document.querySelectorAll('input');
                  //cl("inputmodal",inputM)
                  inputM[inputquery].focus();
                }

                //alert('Em desenvolvimento no backend/servidor');
                onClose();
              }}
            >
              Ok
            </button>
          </div >
        );
      }
    });
  }

  function modalCaixaOpen(data, troco) {
    //    var testeStr = 'Isso é um teste <<nome>>';
    //    testeStr = testeStr.replace('<<nome>>', nome)
    confirmAlert({
      closeOnClickOutside: false,
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            {/* <h1>Deseja Deletar este registro ? {testeStr}</h1><br></br><br></br> */}
            <div className="modal-header">
              <h4 className="modal-title">Abertura de Caixa</h4>
            </div>
            <div className="modal-body">
              <p>Tem certeza que deseja realizar a Abertura para o</p>
              <p>Dia {moment(data).format("DD/MM/YYYY")} com Troco de {troco} ?</p>
            </div>
            <button className="btn bg-gradient-danger btn-sm" onClick={onClose}>Não</button>
            <button
              className="btn bg-gradient-success btn-sm float-right"
              onClick={() => {

                setopenCaixa({
                  open: data,
                  troco: troco,
                  user: global.gIdUser
                })
                onClose();

              }}
            >
              Sim, abrir agora!
            </button>
          </div>
        );
      }
    });
  }

  function confirmDelProp(numprop, cliente) {
    //    var testeStr = 'Isso é um teste <<nome>>';
    //    testeStr = testeStr.replace('<<nome>>', nome)
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            {/* <h1>Deseja Deletar este registro ? {testeStr}</h1><br></br><br></br> */}
            <h1>Deseja Deletar este Contrato da proposta ?</h1><br></br><br></br>
            <p id='pmodal'><b>{numprop} - {cliente}</b></p>
            <br></br>
            <button className="btn bg-gradient-info btn-sm" onClick={onClose}>Não</button>
            <button
              className="btn bg-gradient-danger btn-sm float-right"
              onClick={() => {
                //alert('Em desenvolvimento no backend/servidor');
                /*                 setDelContr(
                                  {
                                    'numprop': numprop
                                  }); */
                onClose();
              }}
            >
              Sim, apague agora!
            </button>
          </div>
        );
      }
    });
  }


  function CaixaFechado(params) {
    return (
      <div id="panelCxClose" name="panelCxClose" style={{ position: 'relative', display: '' }}>
        <section className="content">
          <div className="row">
            {/* Left col */}
            <section className="col-lg-12 connectedSortable ui-sortable">
              {/* Custom tabs (Charts with tabs)*/}

              {/* <div className="card card-info cardAddBgg" > */}
              <div className="card card-danger cardAddBgg" >
                <div className="card-header ui-sortable-handle" >
                  <h3 className="card-title" id="tituloContr">Caixa Fechado</h3>
                  <div className="card-tools">
                    <button type="button" className="btn btn-tool" data-widget="collapse">
                      <i className="fas fa-minus" />
                    </button>
                  </div>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  {/* Conversations are loaded here */}
                  <form id="formAddNewContact">
                    <div className="form-row">
                      <div className="form-group col-md-2">
                        <label htmlFor="lNome">Acesse Caixa / Receber para abrir um novo caixa</label>
                      </div>
                    </div>

                    {/* <button type="button" className="btn btn-info float-right" id="btnGravarClose" onClick={e => CloseEditContr()}>Cancelar</button> */}
                  </form>
                </div>

              </div>
            </section>

          </div>

        </section>
      </div>

    )

  }

  function CaixaAberto(params) {
    return (
      <div id="panelCxOpen" name="panelCxOpen" style={{ position: 'relative', display: '' }}>
        <section className="content">
          <div className="row">
            {/* Left col */}
            <section className="col-lg-12 connectedSortable ui-sortable">
              {/* Custom tabs (Charts with tabs)*/}

              {/* <div className="card card-info cardAddBgg" > */}
              <div className="card card-success cardAddBgg" id="cardSelCaixa" >
                <div className="card-header ui-sortable-handle" >
                  <h3 className="card-title" id="tituloCxOpen">Caixa Aberto</h3>
                  <div className="card-tools">
                    <button type="button" className="btn btn-tool" data-widget="collapse">
                      <i className="fas fa-minus" />
                    </button>
                  </div>
                </div>
                {/* /.card-header */}
                <div className="card-body" id="cardSelCaixaBody">
                  {/* Conversations are loaded here */}
                  <form id="formAddNewContact">
                    <div className="form-row">
                      <div className="form-group col-md-12">
                        <label id="labelDualList" htmlFor="lNome">Movimentações realizadas no Caixa</label>
                        {historicosCredito.erro&&<p className="alert alert-warning" role="alert">Não foi possível consultar os créditos históricos: {historicosCredito.erro}</p>}
                        {historicosCredito.detalhe&&<DetalheHistoricoCreditoCaixa registro={historicosCredito.detalhe} fechar={historicosCredito.fechar}/>}


                        <img id="imgloadingReactTabulatorCxMov" style={{ display: '' }} className="row col-md-12" alt="Loading.." src={Loading}></img>
                        {operacao && <div role="dialog" aria-modal="true" aria-label="Correção operacional" className="card card-info" style={{position:"fixed",top:"50%",left:"50%",transform:"translate(-50%, -50%)",width:"min(760px, 94vw)",maxHeight:"88vh",overflowY:"auto",zIndex:2005,boxShadow:"0 0 0 100vmax rgba(0,0,0,0.55), 0 12px 45px rgba(0,0,0,0.4)"}}>
                          <div className="card-header"><b>{operacao.tipo==='manual'?'Corrigir movimentação manual':'Transferir profissional do atendimento'}</b></div>
                          <div className="card-body">
                            <p>Registro #{operacao.row.id} {operacao.tipo==='profissional'?'· OS '+operacaoAgenda:''}</p>
                            {operacao.tipo==='manual' ? <>
                              <div className="form-group"><label>Descrição</label><input className="form-control" value={operacaoDescricao} readOnly={String(operacao.row.ref||'')==='RECEBIMENTO_CC'} onChange={e=>setOperacaoDescricao(e.target.value)}/>{String(operacao.row.ref||'')==='RECEBIMENTO_CC' && <small className="text-muted">Descrição e vínculo com cliente protegidos; permitido corrigir valor ou cancelar com justificativa.</small>}</div>
                              <div className="form-group"><label>Valor (R$)</label><input className="form-control" value={operacaoValor} onChange={e=>setOperacaoValor(e.target.value)} onBlur={e=>{try{setOperacaoValor(formataCampo(e.target.value))}catch(x){}}}/></div>
                            </> : <>
                              <div className="form-group"><label>Profissional de destino</label><select className="form-control" value={operacaoDestino} onChange={e=>setOperacaoDestino(e.target.value)}>
                                <option value="">Selecione...</option>{[...(Array.isArray(Profis)?Profis:[]).filter(p=>Number(p.id)!==1), {id:1, name:'Marcio'}].sort((a,b)=>String(a.name||a.nome||'').localeCompare(String(b.name||b.nome||''),'pt-BR',{sensitivity:'base'})).map(p=><option key={p.id} value={p.id}>{p.name||p.nome}</option>)}
                              </select></div>
                              <div className="form-group"><label>Serviço específico (opcional para transferir apenas um)</label><select className="form-control" value={operacaoLinha} onChange={e=>setOperacaoLinha(e.target.value)}>
                                <option value="">Agenda inteira (todos os serviços)</option>{operacaoServicos.filter(x=>Number(x.idservico)>0).map(x=><option key={x.id} value={x.id}>Lançamento #{x.id} · Serviço #{x.idservico} · R$ {x.valor} · Profissional #{x.idprof}</option>)}
                              </select></div>
                            </>}
                            <div className="form-group"><label>Justificativa obrigatória (mínimo 20 caracteres)</label><textarea className="form-control" rows="2" value={operacaoMotivo} onChange={e=>setOperacaoMotivo(e.target.value)}/></div>
                            {operacaoErro && <div className="alert alert-danger">{operacaoErro}</div>}
                            {operacao.tipo==='manual' ? <>
                              <button type="button" className="btn btn-info mr-2" disabled={operacaoExecutando} onClick={()=>confirmarOperacao('movimento_editar')}>Salvar correção</button>
                              <button type="button" className="btn btn-danger mr-2" disabled={operacaoExecutando} onClick={()=>confirmarOperacao('movimento_cancelar')}>Cancelar lançamento</button>
                            </> : <button type="button" className="btn btn-success mr-2" disabled={operacaoExecutando} onClick={()=>confirmarOperacao(operacaoLinha?'transferir_servico':'transferir_agenda')}>Transferir e registrar</button>}
                            <button type="button" className="btn btn-secondary" disabled={operacaoExecutando} onClick={()=>setOperacao(null)}>Fechar</button>
                          </div>
                        </div>}
                        {correcaoMov && <div role="dialog" aria-modal="true" aria-label="Corrigir recebimento" className="card card-warning" style={{position:"fixed",top:"50%",left:"50%",transform:"translate(-50%, -50%)",width:"min(850px, 94vw)",maxHeight:"88vh",overflowY:"auto",zIndex:2005,boxShadow:"0 0 0 100vmax rgba(0,0,0,0.55), 0 12px 45px rgba(0,0,0,0.4)",border:"2px solid #e0a800"}}>
                          <div className="card-header"><b>Corrigir recebimento — OS {correcaoMov.idagenda}</b></div>
                          <div className="card-body">
                            <p>Movimento #{correcaoMov.id} — Valor total: <b>R$ {correcaoMov.valor}</b>. A correção é imediata e auditada.</p>
                            <div className="row">
                              {camposPagamento.map(([campo, rotulo]) => <div className="col-md-3 col-sm-6" key={campo}>
                                <label htmlFor={'correcao-' + campo}>{rotulo} (R$)</label>
                                <input id={'correcao-' + campo} className="form-control" type="text" inputMode="decimal"
                                  value={correcaoValores[campo] || ''} onChange={e => ajustarPagamento(campo, e.target.value)} onBlur={e => { try { setCorrecaoValores(v => ({...v, [campo]: formataCampo(e.target.value)})); } catch (_) {} }} disabled={campo === 'troco'}/>
                              </div>)}
                            </div>
                            <div className="form-group" style={{marginTop: 12}}>
                              <label>Justificativa obrigatória (mínimo 20 caracteres)</label>
                              <textarea className="form-control" rows="3" maxLength="1000" value={correcaoMotivo}
                                onChange={e => setCorrecaoMotivo(e.target.value)} />
                            </div>
                            {correcaoErro && <div className="alert alert-danger">{correcaoErro}</div>}
                            <button type="button" className="btn btn-success mr-2" disabled={correcaoSalvando || !correcaoAberturaOK} onClick={salvarCorrecaoMov}>
                              {correcaoSalvando ? 'Gravando...' : 'Revisar e confirmar correção'}
                            </button>
                            <button type="button" className="btn btn-secondary" disabled={correcaoSalvando} onClick={() => setCorrecaoMov(null)}>Cancelar</button>
                          </div>
                        </div>}
                        {adminAgenda && <div className="mbcli-modal-fundo" style={{position:'fixed',inset:0,zIndex:5000,background:'rgba(0,0,0,.65)',display:'flex',justifyContent:'center',alignItems:'center',padding:16}}><div className="card card-info" style={{width:'min(650px,98vw)',maxHeight:'90vh',overflowY:'auto'}}><div className="card-header d-flex justify-content-between align-items-center"><b>Correção administrativa — Movimento #{adminAgenda.row.id}</b><button className="btn btn-secondary btn-sm" disabled={adminCarregando} onClick={()=>{setAdminAgenda(null);setAdminConfirmando(false);}}>Fechar</button></div><div className="card-body"><p>Caixa aberto · exclusivo do usuário ID 1. As alterações abrangem todas as agendas vinculadas ao pagamento.</p>{adminAgenda.info && <><p><b>Agendas:</b> {adminAgenda.info.agendas.map(a=>'#'+a.id).join(', ')}</p><div className="form-group"><label>Operação</label><select className="form-control" value={adminAcao} onChange={e=>{setAdminAcao(e.target.value);setAdminConfirmando(false);}} disabled={adminCarregando}><option value="reverter">Reverter para Revisar e Finalizar (preservar serviços e insumos)</option><option value="cancelar">Cancelar pagamento, agendas, lançamentos e insumos</option></select></div><div className="form-group"><label>Justificativa obrigatória (mínimo 20 caracteres)</label><textarea className="form-control" rows="3" value={adminMotivo} onChange={e=>{setAdminMotivo(e.target.value);setAdminConfirmando(false);}} disabled={adminCarregando}/></div><div className="alert alert-warning">Esta operação cancela o registro financeiro no sistema, mas NÃO devolve dinheiro nem estorna cartão ou PIX na operadora.</div>{realParaNumber(adminAgenda.row.pre_pago||'0')>0&&<div className="alert alert-info">O crédito pré-pago utilizado será devolvido automaticamente ao mesmo cliente, mantendo a forma de origem.</div>}{adminConfirmando && <div className="alert alert-warning" role="alert"><strong>Confirme a operação:</strong> Movimento #{adminAgenda.row.id} — {adminAcao==='cancelar'?'Cancelar integralmente atendimento e pagamento':'Reverter finalização e excluir o recebimento do caixa'}<div className="mt-2"><b>Justificativa:</b> {adminMotivo}</div><small>O registro financeiro será excluído logicamente. Esta ação não estorna valores na operadora.</small></div>}</>}{adminErro && <div className="alert alert-danger">{adminErro}</div>}</div><div className="card-footer d-flex justify-content-end" style={{gap:10}}><button className="btn btn-secondary" disabled={adminCarregando} onClick={()=>{setAdminAgenda(null);setAdminConfirmando(false);}}>Sair sem alterar</button>{adminConfirmando && <button type="button" className="btn btn-outline-secondary" disabled={adminCarregando} onClick={()=>setAdminConfirmando(false)}>Voltar</button>}<button type="button" className={'btn '+(adminAcao==='cancelar'?'btn-danger':'btn-info')} disabled={adminCarregando||!adminAgenda.info||adminMotivo.trim().length<20} onClick={()=>{if(adminConfirmando)executarAdminAgenda();else setAdminConfirmando(true);}}>{adminCarregando?'Processando...':adminConfirmando?(adminAcao==='cancelar'?'Confirmar cancelamento':'Confirmar reversão'):'Revisar operação'}</button></div></div></div>}
{movimentoDetalhe&&<MovimentoAgendasDetalhe movimento={movimentoDetalhe} onClose={()=>setMovimentoDetalhe(null)}/>}
                        {resumoMovimento && <div role="dialog" aria-modal="true" aria-label="Resumo do movimento" style={{position:'fixed',inset:0,zIndex:2500,background:'rgba(0,0,0,.55)',display:'flex',justifyContent:'center',alignItems:'center',padding:12}} onClick={()=>setResumoMovimento(null)}>
                          <div className="card card-info" style={{width:'min(850px,96vw)',maxHeight:'90vh',overflowY:'auto',margin:0}} onClick={e=>e.stopPropagation()}>
                            <div className="card-header d-flex justify-content-between align-items-center"><b>Resumo do movimento #{resumoMovimento.id}</b></div>
                            <div className="card-body">
                              <p><b>Descrição:</b> {resumoMovimento.descricao} · <b>Operação:</b> {resumoMovimento.tipo} · <b>Status:</b> {resumoMovimento.status}</p>
                              <div className="table-responsive"><table className="table table-sm table-bordered table-striped"><thead><tr><th>Total</th><th>Dinheiro</th><th>Troco</th><th>Débito</th><th>Crédito</th><th>Parcelado</th><th>PIX</th><th>Ficha (CC)</th></tr></thead><tbody><tr>{['valor','cash','troco','debito','creditoavista','creditoparc','pix','cc'].map(k=><td key={k}>{resumoMovimento[k] === undefined ? '—' : resumoMovimento[k]}</td>)}</tr></tbody></table></div>
                              {resumoCarregando && <p>Consultando serviços das agendas...</p>}
                              {resumoErro && <div className="alert alert-warning">{resumoErro}</div>}
                              {!resumoCarregando && !resumoAgendas.length && !resumoErro && <p className="text-muted">Movimentação sem agenda vinculada.</p>}
                              {resumoAgendas.map(a=><div key={a.id} className="card card-outline card-info mb-2"><div className="card-header"><b>Agenda #{a.id}</b> · {a.agenda?.start || ''} · Status: {a.agenda?.status || '—'}</div><div className="card-body p-2"><div className="table-responsive"><table className="table table-sm table-striped"><thead><tr><th>Lançamento</th><th>Serviço / produto</th><th>Profissional</th><th>Valor</th><th>Comissão %</th><th>Status</th></tr></thead><tbody>{a.servicos.map(l=><tr key={l.id}><td>{l.id}</td><td>{l.descricao_servico || l.descricao_produto || ('Serviço #'+(l.idservico||'—'))}</td><td>{l.nome_profissional || ('#'+l.idprof)}</td><td>{l.valor}</td><td>{l.porc}</td><td>{l.status}</td></tr>)}</tbody></table></div></div></div>)}
                            </div>
                            <div className="card-footer text-right"><button type="button" className="btn btn-danger" onClick={()=>setResumoMovimento(null)}>Fechar</button></div>
                          </div>
                        </div>}
                        <div id="divReactTabulatorCxMov" >
                          <ReactTabulator
                            name="rcardSelCaixaBody"
                            id="rcardSelCaixaBody"
                            // ref={(ref)}
                            columns={columns}
                            data={historicosCredito.linhas}
                            /*               rowClick={rowClick}
                                          cellClick={rowClick} */
                            options={options}
                            events={{rowClick: clicarLinhaMovimento}}
                          //data-custom-attr="test-custom-attribute"
                          //className="#example-table-theme"
                          />
                        </div>
                      </div>

                    </div>
                  </form>
                </div>

              </div>
            </section>

          </div>

        </section>
      </div>

    )

  }

  function pageRelComiss(params) {
    return (
      <div id="panelRelComiss" name="panelRelComiss" style={{ position: 'relative', display: '' }}>
        <section className="content">
          <div className="row">
            {/* Left col */}
            <section className="col-lg-12 connectedSortable ui-sortable">
              {/* Custom tabs (Charts with tabs)*/}

              {/* <div className="card card-info cardAddBgg" > */}
              <div className="card card-primary cardAddBgg collapsed-card" id="cardSelCaixa" >
                <div className="card-header ui-sortable-handle" >
                  <h3 className="card-title" id="tituloRelComiss">Relatório de Conferência da Semana Atual ({moment().day(1).format('DD/MM')} à {moment().day(7).format('DD/MM/YYYY')})</h3>
                  <div className="card-tools">
                    <button type="button" className="btn btn-tool" data-widget="collapse" >
                      <i className="fas fa-plus" />
                    </button>
                  </div>
                </div>
                {/* /.card-header */}
                <div className="card-body" id="cardSelCaixaBody">
                  {/* Conversations are loaded here */}
                  <form id="formAddNewContact">
                    <div className="form-row">
                      <div className="form-group col-md-12">
                        <label id="labelReactTabulatorCxMov" htmlFor="lNome">Resumo nesta Semana</label>
                        <div id="divReactTabulatorCxMov" >
                          <ReactTabulator
                            name="rcardSelCaixaBody"
                            id="rcardSelCaixaBody"
                            // ref={(ref)}
                            columns={columnsRelResumo}
                            data={RelComissResumo}
                            /*               rowClick={rowClick}
                                          cellClick={rowClick} */
                            options={optionsRelResumo}
                            events={{}}
                          //data-custom-attr="test-custom-attribute"
                          //className="#example-table-theme"
                          /><div>
                            <br />&nbsp;<br />
                          </div>

                        </div>
                        <label id="labelReactTabulatorCxMov" htmlFor="lNome">Apontamentos Localizados nesta Semana</label>
                        {agendaDetalheId&&<MovimentoAgendasDetalhe agendaId={agendaDetalheId} onClose={()=>setAgendaDetalheId(null)}/>}
                        <img id="imgloadingRelComiss" style={{ display: '' }} className="row col-md-12" alt="Loading.." src={Loading}></img>
                        <div id="divReactTabulatorCxMov" >
                          <ReactTabulator
                            name="rcardSelCaixaBody"
                            id="rcardSelCaixaBody"
                            // ref={(ref)}
                            columns={columnsRel}
                            data={montarApontamentosComFlex(RelComiss)}
                            /*               rowClick={rowClick}
                                          cellClick={rowClick} */
                            options={optionsRel}
                            events={{}}
                          //data-custom-attr="test-custom-attribute"
                          //className="#example-table-theme"
                          />
                        </div>
                      </div>

                    </div>
                  </form>
                </div>

              </div>
            </section>

          </div>

        </section>
      </div>

    )

  }

  function Movresumo(params) {
    const prePagamentos = resumirPrePagamentosCaixa(Lancamentos);
    const dataResumoCaixa = global.cxselecionado || (Array.isArray(Lancamentos) && Lancamentos.find(r => r?.open)?.open) || '';
    const dataCaixaCurta = (() => { const m = String(dataResumoCaixa).match(/\d{2}\/\d{2}\/\d{4}/); if (m) return m[0]; const d = moment(dataResumoCaixa); return dataResumoCaixa && d.isValid() ? d.format('DD/MM/YYYY') : ''; })();
    const moedaResumo = centavos => (centavos / 100).toLocaleString('pt-BR', {style:'currency',currency:'BRL'});
    return (
      <div id="panelMovresumo" name="panelMovresumo" style={{ position: 'relative', display: '' }}>
        <section className="content">
          <div className="row">
            {/* Left col */}
            <section className="col-lg-12 connectedSortable ui-sortable">
              {/* Custom tabs (Charts with tabs)*/}

              {/* <div className="card card-info cardAddBgg" > */}
              <div className="card card-info cardAddBgg collapsed-card" id="cardMovAction" >
                <div className="card-header ui-sortable-handle" >
                  <h3 className="card-title" id="tituloCxOpen">Resumo Parcial Caixa Aberto e Vendas (agendas){dataCaixaCurta ? ' - ' + dataCaixaCurta : ''}</h3>
                  <div className="card-tools">
                    <button type="button" className="btn btn-tool" data-widget="collapse">
                      <i className="fas fa-plus" />
                    </button>
                  </div>
                </div>
                {/* /.card-header */}
                <div className="card-body" id="cardSelCaixaBody">
                  {/* Conversations are loaded here */}
                  <form id="formMovActions">
                    <div className="form-row">
                      <div className="form-group col-md-12">
                        <div id="divSaldos" className="resumo-caixa">
                          <div className="resumo-kpis">
                            <div className="resumo-kpi resumo-kpi-entradas">
                              <label id="labelTotal" htmlFor="inputTotal">Total de Entradas</label>
                              <input type="text" className="form-control" disabled id="inputTotal" />
                            </div>
                            <div className="resumo-kpi resumo-kpi-saldo" id="idSaldoCaixa">
                              <label id="labelCash" htmlFor="inputCash">Saldo no Caixa</label>
                              <input type="text" className="form-control" disabled id="inputCash" />
                            </div>
                          </div>
                          <div className="resumo-grid">
                            {[['inputDebito','Débito'],['inputCCv','Crédito à Vista'],['inputCCp','Crédito Parcelado'],['inputPix','PIX'],['inputCC','CC']].map(([id,rotulo]) => <div className="resumo-item" key={id}>
                              <label htmlFor={id}>{rotulo}</label>
                              <input type="text" className="form-control" disabled id={id} />
                            </div>)}
                            {[['pre_pago','Pré-pago utilizado','Pré-pago (s/ entrada)'],['permuta','Permuta utilizada','Permuta (s/ entrada)']].map(([campo,nome,curto])=><div className="resumo-item" key={campo}>
                              <label htmlFor={'inputResumoUso_' + campo} title={nome + ' (sem nova entrada)'}>{curto}</label>
                              <input id={'inputResumoUso_' + campo} className="form-control caixa-resumo-valor" disabled value={(Array.isArray(Lancamentos)?Lancamentos:[]).filter(r=>r.tipo==='E'&&r.status==='inicial').reduce((s,r)=>s+realParaNumber(r[campo]||'0'),0).toLocaleString('pt-BR',{style:'currency',currency:'BRL'})}/>
                            </div>)}
                          </div>
                          <div className="resumo-card">
                            <div className="resumo-card-titulo">Resumo Parcial de Faturamento (Agendas - Caixa de {dataResumoCaixa})</div>
                            <div className="resumo-card-corpo resumo-cols-5">
                              {[['inputTotalagendas','Total - Agendas'],['inputTotalagendascartao','Agenda - Cartão'],['inputTotalagendaspix','Agenda - PIX'],['inputTotalagendascc','Agenda - Ficha(CC)'],['inputTotalagendascash','Agenda - Dinheiro']].map(([id,rotulo]) => <div className="resumo-col" key={id}>
                                <label htmlFor={id}>{rotulo}</label>
                                <input type="text" className="form-control" disabled id={id} />
                              </div>)}
                            </div>
                          </div>
                          <div className="resumo-duo">
                            <div className="resumo-card resumo-card-compacto">
                              <div className="resumo-card-titulo">Resumo Parcial de Vales - Caixa de {dataResumoCaixa}</div>
                              <div className="resumo-card-corpo resumo-cols-1">
                                <div className="resumo-col">
                                  <label htmlFor="inputTotalvales">Total - Vales</label>
                                  <input type="text" className="form-control" disabled id="inputTotalvales" />
                                </div>
                              </div>
                            </div>
                            <div className="resumo-card resumo-card-compacto resumo-card-prepag">
                              <div className="resumo-card-titulo">Resumo Parcial de Pré-pagamentos - Caixa de {dataResumoCaixa}</div>
                              <div className="resumo-card-corpo resumo-cols-3">
                                {[
                                  ['inputTotalPrePagamentos','Total recebido',prePagamentos.recebidos],
                                  ['inputEstornosPrePagamentos','Estornos',prePagamentos.estornados],
                                  ['inputLiquidoPrePagamentos','Entrada líquida',prePagamentos.liquido]
                                ].map(([id,rotulo,valor]) => <div className="resumo-col" key={id}>
                                  <label htmlFor={id}>{rotulo}</label>
                                  <input id={id} type="text" className="form-control caixa-resumo-valor" disabled value={moedaResumo(valor)}/>
                                </div>)}
                              </div>
                              <div className="resumo-card-rodape"><i className="fas fa-info-circle" /> {prePagamentos.quantidade} recebimento(s) de adiantamento neste caixa. O uso nas OS aparece acima e não gera nova entrada.</div>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                  </form>
                </div>

              </div>
            </section>

          </div>

        </section>
      </div>

    )

  }

  function Movaction(params) {
    return (
      <div id="panelMovaction" name="panelMovaction" style={{ position: 'relative', display: '' }}>
        <section className="content">
          <div className="row">
            {/* Left col */}
            <section className="col-lg-12 connectedSortable ui-sortable">
              {/* Custom tabs (Charts with tabs)*/}

              {/* <div className="card card-info cardAddBgg" > */}
              <div className="card card-danger cardAddBgg collapsed-card" id="cardMovAction" >
                <div className="card-header ui-sortable-handle" >
                  <h3 className="card-title" id="tituloCxOpen">Operações</h3>
                  <div className="card-tools">
                    <button type="button" className="btn btn-tool" data-widget="collapse">
                      <i className="fas fa-plus" />
                    </button>
                  </div>
                </div>
                {/* /.card-header */}
                <div className="card-body" id="cardSelCaixaBody">
                  {/* Conversations are loaded here */}
                  <form id="formMovActions">
                    <div className="form-row">
                      <div className="form-group col-md-12">
                        <div id="divSaldos" >
                          <div className="form-row">
                            <div className="form-group col-md-10" id="idSaldoCaixa">

                            </div>
                            <div className="row col-md-12" id="alterarEbotoes">
                              <div className="row col-md-12">
                                <div className="col-sm">
                                  <div className="form-group ">
                                    <div className="mbhair-caixa-acoes">
                                      <button type="button" className="btn btn-success" id="btnMovCxFecharCx" onClick={() => btnconfirmFechaCx()}>Fechar Caixa</button>
                                      <div className="mbhair-caixa-acoes-direita">
                                        <button type="button" className="btn btn-info" id="btnRecebimentoCC" onClick={abrirRecebimentoCC}>Recebimento CC</button>
                                        <button type="button" className="btn btn-danger" id="btnMovCxSaiMan" onClick={() => confirmMovCx()}>Entrada/Saida Manual</button>
                                      </div>
                                    </div>
                                  </div></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                  </form>
                </div>

              </div>
            </section>

          </div>

        </section>
      </div>

    )

  }


  function CaixaFechamento(params) {
    return (
      <div id="panelCxOpen" name="panelCxOpen" style={{ position: 'relative', display: 'none' }}>
        <section className="content">
          <div className="row">
            {/* Left col */}
            <section className="col-lg-12 connectedSortable ui-sortable">
              {/* Custom tabs (Charts with tabs)*/}

              {/* <div className="card card-info cardAddBgg" > */}
              <div className="card card-info cardAddBgg" id="cardSelFech" style={{ display: '' }}>
                <div className="card-header ui-sortable-handle" >
                  <h3 className="card-title" id="tituloCxOpen">Fechamento Selecionado : {global.gLancSelected}</h3>
                  <div className="card-tools">
                    <button type="button" className="btn btn-tool" data-widget="collapse">
                      <i className="fas fa-minus" />
                    </button>
                  </div>
                </div>
                {/* /.card-header */}
                <div className="card-body" id="cardSelFechBody">
                  {/* Conversations are loaded here */}
                  <form id="formAddNewContact">
                    <div className="form-row">
                      <div className="form-group col-md-7">
                        <img id="imgloadingReactTabulatorCxMov" style={{ display: '' }} className="row col-md-12" alt="Loading.." src={Loading}></img>
                        <div id="divReactTabulatorCxMov" >
                          <label htmlFor="lNome">Itens Localizados</label>
                          <ReactTabulator
                            name="rcardSelFechBody"
                            id="rcardSelFechBody"
                            // ref={(ref)}
                            columns={columns}
                            data={Lancamentos}
                            /*               rowClick={rowClick}
                                          cellClick={rowClick} */
                            options={options}
                            events={{}}
                          //data-custom-attr="test-custom-attribute"
                          //className="#example-table-theme"
                          />
                          <label id="labelTotal" htmlFor="lCep">Total</label>
                          <div className="input-group-prepend">
                            <input type="text" className="form-control" disabled id="inputTotal" />
                          </div>
                        </div>
                      </div>
                      <div id="divFormadePG" style={{ display: 'none' }} className="form-group col-md-4">
                        <div className="row">
                          <label id="labelTCalc" name="labelTCalc">Formas de Pagamento</label>
                        </div>
                        <div id="divbtnsFPG" className="form-row">
                          <div className="form-group col-md-6 ">
                            <label htmlFor="lEmail3">Dinheiro</label>
                            <div className="input-group-prepend">
                              <button type="button" id="btnPgCash" className="btn btn-info " onClick={() => btnFPG('inputVCash')} ><i className="fa fa-money"></i> </button>
                              <input type="text" onBlur={() => calcTroco()} onKeyDown={e => keyDetect(e.key)} className="form-control" id="inputVCash" />
                            </div>
                          </div>
                          <div className="form-group col-md-4 ">
                            <label htmlFor="lEmail3">Troco</label>
                            <div className="input-group-prepend">
                              <input type="text" className="form-control" id="inputVTroco" disabled />
                            </div>
                          </div>
                        </div>
                        <div id="divbtnsFPG" className="form-row">
                          <div className="form-group col-md-6 ">
                            <label htmlFor="lEmail3">Débito</label>
                            <div className="input-group-prepend">
                              <button type="button" id="btnPgCD" className="btn btn-info " onClick={() => btnFPG('inputVCD')} ><i className="fa fa-credit-card-alt "></i> </button>
                              <input type="text" className="form-control" id="inputVCD" />
                            </div>
                          </div>
                        </div>
                        <div id="divbtnsFPG" className="form-row">
                          <div className="form-group col-md-6 ">
                            <label htmlFor="lEmail3">Crédito à vista</label>
                            <div className="input-group-prepend">
                              <button type="button" id="btnPgCC" className="btn btn-info " onClick={() => btnFPG('inputVCC')} ><i className="fa fa-credit-card"></i> </button>
                              <input type="text" className="form-control" id="inputVCC" />
                            </div>
                          </div>
                        </div>
                        <div id="divbtnsFPG" className="form-row">
                          <div className="form-group col-md-6 ">
                            <label htmlFor="lEmail3">Crédito Parcelado</label>
                            <div className="input-group-prepend">
                              <button type="button" id="btnPgCCx" className="btn btn-info " onClick={() => btnFPG('inputVCCx')} ><i className="fa fa-credit-card"></i> </button>
                              <input type="text" className="form-control" id="inputVCCx" />
                            </div>
                          </div>
                        </div>
                        <div id="divbtnsFPG" className="form-row">
                          <div className="form-group col-md-6 ">
                            <label htmlFor="lEmail3">PIX</label>
                            <div className="input-group-prepend">
                              <button type="button" id="btnPgPix" className="btn btn-info " onClick={() => btnFPG('inputVPix')} ><i className="fa fa-qrcode"></i> </button>
                              <input type="text" className="form-control" id="inputVPix" />
                            </div>
                          </div>
                        </div>
                        <div id="divbtnsFPG" className="form-row" title="Credito Corrente (Ficha Interna) - Somente um fechamento por vez">
                          <div className="form-group col-md-6 ">
                            <label htmlFor="lEmail3" >CC</label>
                            <div className="input-group-prepend">
                              <button type="button" id="btnPgConta" className="btn btn-info " onClick={() => btnFPG('inputVConta')} ><i className="fa fa-creative-commons "></i> </button>
                              <input type="text" className="form-control" id="inputVConta" />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="form-group col-md-12">
                        <button type="button" className="btn btn-info float-right" id="btnGravar" onClick={e => btnFinalizarPG()}>Finalizar Pagamento</button>
                        <button type="button" className="btn btn-info " id="btnGravarClose" onClick={e => CloseEditContr()}>Cancelar</button>
                      </div>
                    </div>
                  </form>
                </div>

              </div>
            </section>

          </div>

        </section>
      </div>

    )

  }

  function testCaixa(params) {




  }

  function validaNome(params) {
    const eNnome = document.getElementById('inputNome')
    const nome = eNnome.value;
    if (nome.length > 3) {
      eNnome.classList.add("is-valid");
      eNnome.classList.remove("is-invalid");
      global.inpAddFrmC.inputNome = true;
    } else {
      eNnome.classList.add("is-invalid")
      eNnome.classList.remove("is-valid")
      if (params === 1) { eNnome.focus() }
    }
    //eNnome.value = params.toLowerCase();
  }

  function validaCid(params) {
    const eNnome = document.getElementById('inputCidade')
    const nome = eNnome.value;
    if (nome.length > 5) {
      eNnome.classList.add("is-valid")
      eNnome.classList.remove("is-invalid")
      global.inpAddFrmC.inputCid = true;
    } else {
      eNnome.classList.add("is-invalid")
      eNnome.classList.remove("is-valid")
      if (params === 1) { eNnome.focus() }
    }
    //eNnome.value = params.toLowerCase();
  }

  function validaEmail4(params, idinput) {
    const eNemail = document.getElementById('inputEmail4')
    const email = eNemail.value;
    if (EmailValidator.validate(email)) {
      eNemail.classList.add("is-valid")
      eNemail.classList.remove("is-invalid")
      global.inpAddFrmC.inputEmail4 = true;
      //cl("true global valida", global.inpAddFrmC)
    } else {
      eNemail.classList.add("is-invalid")
      eNemail.classList.remove("is-valid")
      //cl("FALSE global valida", global.inpAddFrmC, params)
      if (params === 1) { return eNemail.focus() }
    }
    if (email) { eNemail.value = params.toLowerCase() };

  }

  function validaFone(params) {
    const eNnome = document.getElementById('inputFone')
    const nomep = eNnome.value;
    const nome = nomep.replace(/_|-/g, '');
    ////cl(nome)
    if (nome.length > 9) {
      eNnome.classList.add("is-valid")
      eNnome.classList.remove("is-invalid")
      //global.inpAddFrmC.inputFone = true;
    } else {
      eNnome.classList.add("is-invalid")
      eNnome.classList.remove("is-valid")
      if (params === 1) { eNnome.focus() }
    }
    //eNnome.value = params.toLowerCase();
    let im = new Inputmask("(99) 99999-9999");
    im.mask(eNnome);

  }

  function formataFone(params) {
    const nome = params.replace(/_|-/g, '');
    ////cl(nome)
    //eNnome.value = params.toLowerCase();
    let im = new Inputmask("99-999999999");
    let result = im.mask(params);
    return result;

  }


  function validaObs(params) {
    const eNnome = document.getElementById('inputObs')
    const nome = eNnome.value;
    if (nome.length > 5) {
      eNnome.classList.add("is-valid")
      eNnome.classList.remove("is-invalid")
      global.inpAddFrmC.inputObs = true;
    } else {
      eNnome.classList.add("is-invalid")
      eNnome.classList.remove("is-valid")
      if (params === 1) { eNnome.focus() }
    }
    //eNnome.value = params.toLowerCase();
  }

  function CloseEditContr(params) {
    btnFPGresetAll();
    dualChangeLancReset();
    AtuRefresh();
    let ecardSelCaixa = document.getElementById('cardSelCaixa');
    ecardSelCaixa.classList.remove("collapsed-card");

    let ecardSelCaixaBody = document.getElementById('cardSelCaixaBody');
    if (ecardSelCaixaBody) { ecardSelCaixaBody.style.display = ''; }

    let ecardSelFech = document.getElementById('cardSelFech');
    if (ecardSelFech) { ecardSelFech.style.display = 'none'; }

  }

  function AtuRefresh(params) {

    setAtuLanc({ '0': '0' });

  }

  function btnFPGresetAll(params) {
    let einputVCash = document.getElementById('inputVCash');
    if (einputVCash) { einputVCash.value = ''; }
    let einputVTroco = document.getElementById('inputVTroco');
    if (einputVTroco) { einputVTroco.value = ''; }
    let einputVCD = document.getElementById('inputVCD');
    if (einputVCD) { einputVCD.value = ''; }
    let einputVCC = document.getElementById('inputVCC');
    if (einputVCC) { einputVCC.value = ''; }
    let einputVCCx = document.getElementById('inputVCCx');
    if (einputVCCx) { einputVCCx.value = ''; }
    let einputVPix = document.getElementById('inputVPix');
    if (einputVPix) { einputVPix.value = ''; }
    let einputVConta = document.getElementById('inputVConta');
    if (einputVConta) { einputVConta.value = ''; }

    /*     let einputVCash = document.getElementById('inputVCash');
        if (einputVCash) { einputVCash.value = (0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }); }
        let einputVCD = document.getElementById('inputVCD');
        if (einputVCD) { einputVCD.value = (0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }); }
        let einputVCC = document.getElementById('inputVCC');
        if (einputVCC) { einputVCC.value = (0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }); }
        let einputVCCx = document.getElementById('inputVCCx');
        if (einputVCCx) { einputVCCx.value = (0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }); }
        let einputVPix = document.getElementById('inputVPix');
        if (einputVPix) { einputVPix.value = (0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }); }
        let einputVConta = document.getElementById('inputVConta');
        if (einputVConta) { einputVConta.value = (0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }); } */
  }

  function btnFPG(params) {
    btnFPGresetAll();
    let eparams = document.getElementById(params);
    if (eparams) {
      eparams.value = global.gSubTotal.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
      eparams.focus();
    }

  }

  function calcTroco(params) {
    let einputVCash = document.getElementById('inputVCash');
    let einputVTroco = document.getElementById('inputVTroco');
    let cash = realParaNumber(einputVCash.value);
    let troco = 0;
    //cl(LancSelected);
    troco = cash - global.gSubTotal
    if (troco > 0) {
      let einputVCashFormat = cash.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
      einputVCash.value = einputVCashFormat;
      //cl(einputVCashFormat);
      einputVTroco.value = troco.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });

    } else {
      let trocozero = 0;
      let einputVCashFormat = einputVCash.value.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
      einputVCash.value = einputVCash.value.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
      //cl(einputVCashFormat);
      einputVTroco.value = trocozero.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
    }

    //cl("troco",troco);

  }

  function dualChangeLanc(params) {
    let eimgloadingReactTabulatorCxMov = document.getElementById('imgloadingReactTabulatorCxMov');
    if (eimgloadingReactTabulatorCxMov) { eimgloadingReactTabulatorCxMov.style.display = ''; }
    global.gParams = params;
    setLancSelected(params)
    //cl("params", params)
    setAtuLancamentos({ idagenda: global.gParams })
    setAtuRelComiss({ idagenda: global.gParams })
    setAtuRelComissResumo({ idagenda: global.gParams })
    let qtd = 0;
    var i;
    var j;

    for (i = 0; i < params.length; i++) {
      // cl("params_i", params[i])
      let idfilter = params[i];
      var arrFound = Lanc.filter(function (item, num) {
        return item.value === idfilter;
      });
      let idcliente = arrFound[0]['cliente'];
      var arrFoundCli = Lanc.filter(function (item, num) {
        return item.cliente === idcliente;
      });

      // cl("arrFound", arrFound[0]['cliente'])
      // cl("arrFoundCli", arrFoundCli)

      for (j = 0; j < Lanc.length; j++) {
        //cl("compLanc",arrFound[0]['cliente'])
        if (Lanc[j]['cliente'] === arrFound[0]['cliente']) {
          cl("Somou Lanc")
          qtd = qtd + 1;
        }
      }
    }

    if (qtd > 1) {
      //window.alert("Atenção : existem mais de um fechamento em aberto deste cliente! ")
      setLanc(arrFoundCli);
      //cl("params.length", params.length)
      // cl("arrFoundCli.length", arrFoundCli.length)

      if (arrFoundCli.length !== params.length) {

        modalBase("Atenção", "Existem mais de um fechamento em aberto deste cliente!");

      } else {
        qtd = 1;
      }
    }



    if (params.length > 0) {


      let ecardSelCaixa = document.getElementById('cardSelCaixa');

      let ecardSelCaixaBody = document.getElementById('cardSelCaixaBody');
      if (qtd > 1) {
        if (ecardSelCaixaBody) { ecardSelCaixaBody.style.display = ''; }
        ecardSelCaixa.classList.remove("collapsed-card");
      } else {
        if (ecardSelCaixaBody) { ecardSelCaixaBody.style.display = 'none'; }
        ecardSelCaixa.classList.add("collapsed-card");

      }

      let ecardSelFech = document.getElementById('cardSelFech');
      if (ecardSelFech) { ecardSelFech.style.display = ''; }


    } else {

      let ecardSelFech = document.getElementById('cardSelFech');
      if (ecardSelFech) { ecardSelFech.style.display = 'none'; }

    }


  }

  function keyDetect(params) {

    if (params === "Enter") {

      calcTroco();

      //  cl("key", params)
    }


  }

  function dualChangeLancReset(params) {
    global.gParams = [];
    setLancSelected();
    //cl("params", params)
    setAtuLancamentos({ idagenda: global.gParams })
    setAtuRelComiss({ idagenda: global.gParams })
    setAtuRelComissResumo({ idagenda: global.gParams })
    AtuRefresh();

  }


  if (repCaixaOpen.length < 1) {
    //if (0 == 1) {
    return (
      <div className="content-wrapper" >
        <div className="container-login100-form-btn">
          <img id="imgloading" width="250px" alt="Loading.." src={Loading}></img>

        </div>
        <div className="text-center p-t-30">Aguarde, Localizando Caixa ...</div>
      </div >
    )
  } else {
    return (
      <div className="content-wrapper">
        {CaixaFechado()}
        {CaixaAberto()}
        {Movresumo()}
        {Movaction()}
        {pageRelComiss()}
        {/* {testCaixa()} */}
      </div>
    )

  }



}

export default Gerador   